export const I18N_KEYS = {
  COMMON_COMPONENTS: {
    COPYRIGHT: 'COMMON_COMPONENTS_COPYRIGHT',
    FILE_UPLOADER: {
      CTA: 'COMMON_COMPONENTS_FILE_UPLOADER_CTA',
      NO_PREVIEW: 'COMMON_COMPONENTS_FILE_UPLOADER_NO_PREVIEW',
      OR: 'COMMON_COMPONENTS_FILE_UPLOADER_OR',
      PASTE_LINK: 'COMMON_COMPONENTS_FILE_UPLOADER_PASTE_LINK',
      REMOVE_FILE: 'COMMON_COMPONENTS_FILE_UPLOADER_REMOVE_FILE',
      REPLACE_FILE: 'COMMON_COMPONENTS_FILE_UPLOADER_REPLACE_FILE',
      ADD_FILE: 'COMMON_COMPONENTS_FILE_UPLOADER_ADD_FILE',
      UPLOAD_FROM_LINK: 'COMMON_COMPONENTS_FILE_UPLOADER_UPLOAD_FROM_LINK',
    },
    NODE_IMAGE_LIST: {
      NO_PREVIEW: 'COMMON_COMPONENTS_NODE_IMAGE_LIST_NO_PREVIEW',
      RESULT: 'COMMON_COMPONENTS_NODE_IMAGE_LIST_RESULT',
    },
    THREE_DEE_VIEWER: {
      ERROR: 'COMMON_COMPONENTS_THREE_DEE_VIEWER_ERROR',
    },
    BASE_SELECT: {
      NO_OPTIONS_TEXT: 'COMMON_COMPONENTS_BASE_SELECT_NO_OPTIONS_TEXT',
    },
    EXPENSIVE_RUN_MODAL: {
      TITLE: 'COMMON_COMPONENTS_EXPENSIVE_RUN_MODAL_TITLE',
      SUBTITLE: 'COMMON_COMPONENTS_EXPENSIVE_RUN_MODAL_SUBTITLE',
      CHECKBOX_LABEL: 'COMMON_COMPONENTS_EXPENSIVE_RUN_MODAL_CHECKBOX_LABEL',
      CTA_CONFIRM: 'COMMON_COMPONENTS_EXPENSIVE_RUN_MODAL_CTA_CONFIRM',
      CTA_CANCEL: 'COMMON_COMPONENTS_EXPENSIVE_RUN_MODAL_CTA_CANCEL',
    },
    PRICE_INFO: {
      TITLE: 'COMMON_COMPONENTS_PRICE_INFO_TITLE',
      CREDITS: 'COMMON_COMPONENTS_PRICE_INFO_CREDITS',
    },
  },
  COMPOSITOR: {
    MISSING_URL_TOOLTIP: 'COMPOSITOR_MISSING_URL_TOOLTIP',
    MISSING_WORKSPACE_FONTS_MODAL: {
      TITLE: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_TITLE',
      DESCRIPTION: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_DESCRIPTION',
      CONTINUE: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_CONTINUE',
      COLUMN_MISSING: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_COLUMN_MISSING',
      COLUMN_REPLACEMENT: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_COLUMN_REPLACEMENT',
      SELECT_FONT: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_SELECT_FONT',
      MIXED_REPLACEMENT_FONT: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_MIXED_REPLACEMENT_FONT',
      SELECT_STYLE: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_SELECT_STYLE',
      REPLACE: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_REPLACE',
    },
    LAYER_PANEL: {
      TITLE: 'COMPOSITOR_LAYER_PANEL_TITLE',
    },
    LAYER_PANEL_ROW: {
      CANVAS_LAYER_NAME: 'COMPOSITOR_LAYER_PANEL_ROW_CANVAS_LAYER_NAME',
    },
    LAYER_PROPERTY_PANEL: {
      BLEND_MODE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE',
      FLIP: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FLIP',
      ALIGNMENT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ALIGNMENT',
      CANVAS_LAYER_NAME: 'COMPOSITOR_LAYER_PROPERTY_PANEL_CANVAS_LAYER_NAME',
      DIMENSIONS: 'COMPOSITOR_LAYER_PROPERTY_PANEL_DIMENSIONS',
      TIMELINE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_TIMELINE',
      TIMELINE_INFO: 'COMPOSITOR_LAYER_PROPERTY_PANEL_TIMELINE_INFO',
      DURATION: 'COMPOSITOR_LAYER_PROPERTY_PANEL_DURATION',
      FPS: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FPS',
      FILL: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FILL',
      FONT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT',
      FONT_LETTER_SPACING: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_LETTER_SPACING',
      FONT_LINE_HEIGHT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_LINE_HEIGHT',
      FONT_SIZE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_SIZE',
      FONT_STYLE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_STYLE',
      OPACITY: 'COMPOSITOR_LAYER_PROPERTY_PANEL_OPACITY',
      POSITION: 'COMPOSITOR_LAYER_PROPERTY_PANEL_POSITION',
      ROTATION: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ROTATION',
      FONT_WEIGHT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHT',
      FONT_ALIGN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_ALIGN',
      BLEND_MODES: {
        NORMAL: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_NORMAL',
        MULTIPLY: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_MULTIPLY',
        SCREEN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_SCREEN',
        OVERLAY: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_OVERLAY',
        DARKEN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_DARKEN',
        LIGHTEN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_LIGHTEN',
        COLOR_DODGE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_COLOR_DODGE',
        COLOR_BURN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_COLOR_BURN',
        HARD_LIGHT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_HARD_LIGHT',
        SOFT_LIGHT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_SOFT_LIGHT',
        DIFFERENCE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_DIFFERENCE',
        EXCLUSION: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_EXCLUSION',
        HUE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_HUE',
        SATURATION: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_SATURATION',
        COLOR: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_COLOR',
        LUMINOSITY: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_LUMINOSITY',
        ADD: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_ADD',
      },
      FONT_SELECT_INPUT: {
        HELPER_TEXT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_SELECT_INPUT_HELPER_TEXT',
        NO_OPTIONS_TEXT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_SELECT_INPUT_NO_OPTIONS_TEXT',
      },
      FONT_STYLES: {
        NORMAL: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_STYLES_NORMAL',
        ITALIC: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_STYLES_ITALIC',
      },
      FONT_WEIGHTS: {
        THIN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_THIN',
        EXTRA_LIGHT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_EXTRA_LIGHT',
        LIGHT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_LIGHT',
        REGULAR: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_REGULAR',
        MEDIUM: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_MEDIUM',
        SEMI_BOLD: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_SEMI_BOLD',
        BOLD: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_BOLD',
        EXTRA_BOLD: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_EXTRA_BOLD',
        BLACK: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_BLACK',
        EXTRA_BLACK: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_EXTRA_BLACK',
      },
      ALIGN_OPTIONS: {
        TOP: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ALIGN_OPTIONS_TOP',
        CENTER: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ALIGN_OPTIONS_CENTER',
        BOTTOM: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ALIGN_OPTIONS_BOTTOM',
        LEFT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ALIGN_OPTIONS_LEFT',
        RIGHT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ALIGN_OPTIONS_RIGHT',
      },
    },
  },
  ERROR_PAGE: {
    TITLE: 'ERROR_PAGE_TITLE',
    DESCRIPTION: 'ERROR_PAGE_DESCRIPTION',
    RECOVERED_FROM_ERROR: 'ERROR_PAGE_RECOVERED_FROM_ERROR',
  },
  FLOW_WARNINGS: {
    FAILED_DESERIALIZE_3D_MODEL: 'FLOW_WARNINGS_FAILED_DESERIALIZE_3D_MODEL',
    FAILED_DESERIALIZE_FONT: 'FLOW_WARNINGS_FAILED_DESERIALIZE_FONT',
    FAILED_DESERIALIZE_IMAGE: 'FLOW_WARNINGS_FAILED_DESERIALIZE_IMAGE',
    FAILED_DESERIALIZE_VIDEO: 'FLOW_WARNINGS_FAILED_DESERIALIZE_VIDEO',
    FAILED_DOWNLOAD_IMAGE: 'FLOW_WARNINGS_FAILED_DOWNLOAD_IMAGE',
    FAILED_DOWNLOAD_VIDEO: 'FLOW_WARNINGS_FAILED_DOWNLOAD_VIDEO',
    FAILED_DOWNLOAD_FONT: 'FLOW_WARNINGS_FAILED_DOWNLOAD_FONT',
    FAILED_DOWNLOAD_3D_MODEL: 'FLOW_WARNINGS_FAILED_DOWNLOAD_3D_MODEL',
    FAILED_LOAD_WORKSPACE_CUSTOM_FONTS: 'FLOW_WARNINGS_FAILED_LOAD_WORKSPACE_CUSTOM_FONTS',
  },
  WEBGL_NOT_SUPPORTED_PAGE: {
    TITLE: 'WEBGL_NOT_SUPPORTED_PAGE_TITLE',
    DESCRIPTION: 'WEBGL_NOT_SUPPORTED_PAGE_DESCRIPTION',
  },
  GPU_DRIVER_ERROR_PAGE: {
    TITLE: 'GPU_DRIVER_ERROR_PAGE_TITLE',
    DESCRIPTION: 'GPU_DRIVER_ERROR_PAGE_DESCRIPTION',
    STEP_REFRESH_TITLE: 'GPU_DRIVER_ERROR_PAGE_STEP_REFRESH_TITLE',
    STEP_REFRESH_DESCRIPTION: 'GPU_DRIVER_ERROR_PAGE_STEP_REFRESH_DESCRIPTION',
    STEP_HARDWARE_ACCELERATION_TITLE: 'GPU_DRIVER_ERROR_PAGE_STEP_HARDWARE_ACCELERATION_TITLE',
    STEP_HARDWARE_ACCELERATION_DESCRIPTION: 'GPU_DRIVER_ERROR_PAGE_STEP_HARDWARE_ACCELERATION_DESCRIPTION',
    STEP_RESTART_TITLE: 'GPU_DRIVER_ERROR_PAGE_STEP_RESTART_TITLE',
    STEP_RESTART_DESCRIPTION: 'GPU_DRIVER_ERROR_PAGE_STEP_RESTART_DESCRIPTION',
    STEP_CONTACT_SUPPORT_TITLE: 'GPU_DRIVER_ERROR_PAGE_STEP_CONTACT_SUPPORT_TITLE',
    STEP_CONTACT_SUPPORT_DESCRIPTION: 'GPU_DRIVER_ERROR_PAGE_STEP_CONTACT_SUPPORT_DESCRIPTION',
  },
  FIGMA_COMPOSITOR: {
    LOAD_IMAGE_ERROR: 'FIGMA_COMPOSITOR_LOAD_IMAGE_ERROR',
    ALREADY_CONNECTED_ERROR: 'FIGMA_COMPOSITOR_ALREADY_CONNECTED_ERROR',
    OPEN_IN_FIGMA: 'FIGMA_COMPOSITOR_OPEN_IN_FIGMA',
    REFRESH: 'REFRESH',
    LAYERS: 'COMPOSITOR_LAYERS',
  },
  FLOW_NAVBAR: {
    SHARED_DESIGN_APP_BUTTON: 'FLOW_NAVBAR_SHARED_DESIGN_APP_BUTTON',
    GET_MORE_CREDITS: 'FLOW_NAVBAR_GET_MORE_CREDITS',
    GET_MORE_CREDITS_V2: 'FLOW_NAVBAR_GET_MORE_CREDITS_V2',
    LOW_CREDITS_LABEL: 'FLOW_NAVBAR_LOW_CREDITS_LABEL',
  },
  GENERAL: {
    CANCEL: 'GENERAL_CANCEL',
    CLEAR: 'GENERAL_CLEAR',
    CLOSE: 'GENERAL_CLOSE',
    CONFIRM: 'GENERAL_CONFIRM',
    COPIED: 'GENERAL_COPIED',
    COPY_LINK: 'GENERAL_COPY_LINK',
    COPY: 'GENERAL_COPY',
    CREDIT: 'GENERAL_CREDIT',
    CREDITS: 'GENERAL_CREDITS',
    CREDITS_DISPLAY: 'GENERAL_CREDITS_DISPLAY',
    DONE: 'GENERAL_DONE',
    DOWNLOAD: 'GENERAL_DOWNLOAD',
    ERROR: 'GENERAL_ERROR',
    FILE: 'GENERAL_FILE',
    FILES: 'GENERAL_FILES',
    FROM: 'GENERAL_FROM',
    IMAGE: 'GENERAL_IMAGE',
    INPUT: 'GENERAL_INPUT',
    INVALID_URL: 'ERROR_INVALID_URL',
    MONTH: 'GENERAL_MONTH',
    NAME: 'GENERAL_NAME',
    OUTPUT: 'GENERAL_OUTPUT',
    RENAME: 'GENERAL_RENAME',
    SAVE: 'GENERAL_SAVE',
    SAVING: 'GENERAL_SAVING',
    SEARCH: 'GENERAL_SEARCH',
    TO: 'GENERAL_TO',
    UNKNOWN: 'GENERAL_UNKNOWN',
    UNKNOWN_ERROR: 'GENERAL_UNKNOWN_ERROR',
    UPLOAD_ERROR: 'GENERAL_UPLOAD_ERROR',
    URL: 'GENERAL_URL',
    USER: 'GENERAL_USER',
    YEAR: 'GENERAL_YEAR',
    LORA_WEIGHT: 'GENERAL_LORA_WEIGHT',
    YOU: 'GENERAL_YOU',
    RELOAD_ALERT_TITLE: 'GENERAL_RELOAD_ALERT_TITLE',
    RELOAD_ALERT_CTA: 'GENERAL_RELOAD_ALERT_CTA',
    PAGE_TITLE: 'GENERAL_PAGE_TITLE',
    YES: 'GENERAL_YES',
    NO: 'GENERAL_NO',
    FILTER: 'GENERAL_FILTER',
    FILTERS: 'GENERAL_FILTERS',
    RUNNING: 'GENERAL_RUNNING',
    COMPLETED: 'GENERAL_COMPLETED',
    TYPE: 'GENERAL_TYPE',
    EMAIL: 'GENERAL_EMAIL',
    ROLE: 'GENERAL_ROLE',
    COLOR: 'GENERAL_COLOR',
    APPROVE: 'GENERAL_APPROVE',
    ACCEPT: 'GENERAL_ACCEPT',
    DELETE: 'GENERAL_DELETE',
    FILE_TYPES: {
      IMAGE: 'GENERAL_FILE_TYPES_IMAGE',
      VIDEO: 'GENERAL_FILE_TYPES_VIDEO',
      AUDIO: 'GENERAL_FILE_TYPES_AUDIO',
      THREE_D: 'GENERAL_FILE_TYPES_THREE_D',
    },
  },
  MAIN_DASHBOARD: {
    CONTEXT_MENU: {
      DUPLICATE: 'MAIN_DASHBOARD_CONTEXT_MENU_DUPLICATE',
      EDIT: 'MAIN_DASHBOARD_CONTEXT_MENU_EDIT',
      OPEN: 'MAIN_DASHBOARD_CONTEXT_MENU_OPEN',
      OPEN_NEW_TAB: 'MAIN_DASHBOARD_CONTEXT_MENU_OPEN_NEW_TAB',
      RENAME: 'MAIN_DASHBOARD_CONTEXT_MENU_RENAME',
      MOVE: 'MAIN_DASHBOARD_CONTEXT_MENU_MOVE',
      CHANGE_OWNER: 'MAIN_DASHBOARD_CONTEXT_MENU_CHANGE_OWNER',
      CREATE_FOLDER: 'MAIN_DASHBOARD_CONTEXT_MENU_CREATE_FOLDER',
      CREATE_FILE: 'MAIN_DASHBOARD_CONTEXT_MENU_CREATE_FILE',
      MOVE_TO_TRASH: 'MAIN_DASHBOARD_CONTEXT_MENU_MOVE_TO_TRASH',
    },
    CREATE_NEW_FILE: 'MAIN_DASHBOARD_CREATE_NEW_FILE',
    CREATE_FOLDER_MODAL: {
      TITLE: 'MAIN_DASHBOARD_CREATE_FOLDER_MODAL_TITLE',
      NAME_LABEL: 'MAIN_DASHBOARD_CREATE_FOLDER_MODAL_NAME_LABEL',
      CANCEL: 'MAIN_DASHBOARD_CREATE_FOLDER_MODAL_CANCEL',
      CREATE: 'MAIN_DASHBOARD_CREATE_FOLDER_MODAL_CREATE',
      SUCCESS: 'MAIN_DASHBOARD_CREATE_FOLDER_MODAL_SUCCESS',
      ERROR_PREFIX: 'MAIN_DASHBOARD_CREATE_FOLDER_MODAL_ERROR_PREFIX',
    },
    FOLDER_CARD: {
      FILE_COUNT_SINGULAR: 'MAIN_DASHBOARD_FOLDER_CARD_FILE_COUNT_SINGULAR',
      FILE_COUNT_PLURAL: 'MAIN_DASHBOARD_FOLDER_CARD_FILE_COUNT_PLURAL',
    },
    MOVE_MODAL: {
      TITLE: 'MAIN_DASHBOARD_MOVE_MODAL_TITLE',
      CURRENT_LOCATION: 'MAIN_DASHBOARD_MOVE_MODAL_CURRENT_LOCATION',
      CANCEL: 'MAIN_DASHBOARD_MOVE_MODAL_CANCEL',
      MOVE: 'MAIN_DASHBOARD_MOVE_MODAL_MOVE',
      SUCCESS_FILE: 'MAIN_DASHBOARD_MOVE_MODAL_SUCCESS_FILE',
      SUCCESS_FOLDER: 'MAIN_DASHBOARD_MOVE_MODAL_SUCCESS_FOLDER',
      ERROR_PREFIX: 'MAIN_DASHBOARD_MOVE_MODAL_ERROR_PREFIX',
      CURRENT: 'MAIN_DASHBOARD_MOVE_MODAL_CURRENT',
    },
    DELETE_DIALOG: {
      CONFIRM: 'MAIN_DASHBOARD_DELETE_DIALOG_CONFIRM',
      CONFIRMATION_DELETE_APP: 'MAIN_DASHBOARD_DELETE_DIALOG_CONFIRMATION_DELETE_APP',
      TITLE: 'MAIN_DASHBOARD_DELETE_DIALOG_TITLE',
      MSG: 'MAIN_DASHBOARD_DELETE_DIALOG_MSG',
      CONFIRM_DELETE: 'MAIN_DASHBOARD_DELETE_DIALOG_CONFIRM_DELETE',
    },
    DELETE_FOLDER_SUCCESS: 'MAIN_DASHBOARD_DELETE_FOLDER_SUCCESS',
    DELETE_FOLDER_ERROR: 'MAIN_DASHBOARD_DELETE_FOLDER_ERROR',
    DELETE_WORKFLOW_SUCCESS: 'MAIN_DASHBOARD_DELETE_WORKFLOW_SUCCESS',
    DELETE_WORKFLOW_ERROR: 'MAIN_DASHBOARD_DELETE_WORKFLOW_ERROR',
    RENAME_FOLDER_ERROR: 'MAIN_DASHBOARD_RENAME_FOLDER_ERROR',
    EDUCATION_GALLERY: {
      TUTORIALS: 'MAIN_DASHBOARD_TUTORIALS',
      WORKFLOWS: 'MAIN_DASHBOARD_WORKFLOWS',
    },
    ERROR_LOADING_WORKFLOWS: {
      TITLE: 'MAIN_DASHBOARD_ERROR_LOADING_RECIPES_TITLE',
      ACTION: 'MAIN_DASHBOARD_ERROR_LOADING_RECIPES_ACTION',
    },
    SEARCH_PLACEHOLDER: 'MAIN_DASHBOARD_SEARCH_PLACEHOLDER',
    SEARCH_NO_RESULTS: {
      TITLE: 'MAIN_DASHBOARD_SEARCH_NO_RESULTS_TITLE',
      DESCRIPTION: 'MAIN_DASHBOARD_SEARCH_NO_RESULTS_DESCRIPTION',
    },
    FOLDER_EMPTY: {
      TITLE: 'MAIN_DASHBOARD_FOLDER_EMPTY_TITLE',
      DESCRIPTION: 'MAIN_DASHBOARD_FOLDER_EMPTY_DESCRIPTION',
    },
    SECTION_TITLE: {
      RECENT: 'MAIN_DASHBOARD_SECTION_TITLE_RECENT',
    },
    USERMENU: {
      CREDITS: 'MAIN_DASHBOARD_USERMENU_CREDITS',
      TEAM_CREDITS: 'MAIN_DASHBOARD_USERMENU_TEAM_CREDITS',
      CTA_CREDITS: 'MAIN_DASHBOARD_USERMENU_CTA_CREDITS',
      CTA_CREDITS_FREE: 'MAIN_DASHBOARD_USERMENU_CTA_CREDITS_FREE',
      CTA_PLAN: 'MAIN_DASHBOARD_USERMENU_CTA_PLAN',
      MENU_ITEM_SETTINGS: 'MAIN_DASHBOARD_USERMENU_MENU_ITEM_SETTINGS',
      PLAN: 'MAIN_DASHBOARD_USERMENU_PLAN',
      TEAM_HINT_CREDITS_EMPTY: 'MAIN_DASHBOARD_USERMENU_TEAM_HINT_CREDITS_EMPTY',
    },
    WORKSPACES_MENU: {
      TITLE: 'MAIN_DASHBOARD_WORKSPACES_MENU_TITLE',
    },
    CHANGE_OWNER_MODAL: {
      TITLE: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_TITLE',
      SUBTITLE: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_SUBTITLE',
      SELECT_OWNER: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_SELECT_OWNER',
      CANCEL: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_CANCEL',
      CONFIRM: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_CONFIRM',
      CONFIRM_LOADING: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_CONFIRM_LOADING',
      SUCCESS_SNACKBAR: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_SUCCESS_SNACKBAR',
      WARNING: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_WARNING',
      ERROR_SNACKBAR: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_ERROR_SNACKBAR',
    },
  },
  MOBILE_UNSUPPORTED_PAGE: {
    COPY_LINK_BUTTON: 'MOBILE_UNSUPPORTED_PAGE_COPY_LINK_BUTTON',
    DISCORD_BUTTON: 'MOBILE_UNSUPPORTED_PAGE_DISCORD_BUTTON',
    FOOTER_TEXT: 'MOBILE_UNSUPPORTED_PAGE_FOOTER_TEXT',
    SUBTITLE: 'MOBILE_UNSUPPORTED_PAGE_SUBTITLE',
    TITLE: 'MOBILE_UNSUPPORTED_PAGE_TITLE',
    YOUTUBE_INTRO_BUTTON: 'MOBILE_UNSUPPORTED_PAGE_YOUTUBE_INTRO_BUTTON',
  },
  NAVIGATION_DRAWER: {
    BUY_MORE: 'NAVIGATION_DRAWER_BUY_MORE',
    CREATE_NEW_FILE: 'NAVIGATION_DRAWER_CREATE_NEW_FILE',
    MY_FILES: 'NAVIGATION_DRAWER_MY_FILES',
    SHARED_WITH_ME: 'NAVIGATION_DRAWER_SHARED_WITH_ME',
    WORKSPACE_FILES: 'NAVIGATION_DRAWER_WORKSPACE_FILES',
    APPS: 'NAVIGATION_DRAWER_APPS',
    FAVORITES: 'NAVIGATION_DRAWER_FAVORITES',
    MODELS_SECTION: 'NAVIGATION_DRAWER_MODELS_SECTION',
    MODELS: 'NAVIGATION_DRAWER_MODELS',
    COMMUNITY: 'NAVIGATION_DRAWER_COMMUNITY',
    DISCORD_TITLE: 'NAVIGATION_DRAWER_DISCORD_TITLE',
    DISCORD_TEXT: 'NAVIGATION_DRAWER_DISCORD_TEXT',
    DISCORD_CTA: 'NAVIGATION_DRAWER_DISCORD_CTA',
    NEW_FILE: 'NAVIGATION_DRAWER_NEW_FILE',
    NEW_FOLDER: 'NAVIGATION_DRAWER_NEW_FOLDER',
    ARCHIVE: 'NAVIGATION_DRAWER_ARCHIVE',
  },
  NODE_IMAGE_LIST: {
    CAMERA_CONTROLS: {
      LOCK: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_LOCK',
      UNLOCK: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_UNLOCK',
    },
    CONTEXT_MENU: {
      DOWNLOAD: 'NODE_IMAGE_LIST_CONTEXT_DOWNLOAD',
      DOWNLOAD_ALL: 'NODE_IMAGE_LIST_CONTEXT_DOWNLOAD_ALL',
      SET_AS_COVER: 'NODE_IMAGE_LIST_CONTEXT_MENU_SET_AS_COVER',
      COPY_IMAGE: 'NODE_IMAGE_LIST_CONTEXT_MENU_COPY_IMAGE',
    },
    DELETE_ALL: 'NODE_IMAGE_LIST_DELETE_ALL',
    DELETE_ALL_OTHERS: 'NODE_IMAGE_LIST_DELETE_ALL_OTHERS',
    DELETE_CURRENT: 'NODE_IMAGE_LIST_DELETE_CURRENT',
  },
  PAYMENTS: {
    PRICING_TABLE: {
      TITLE: 'PAYMENTS_PRICING_TABLE_TITLE',
      SUBTITLE: {
        ALL_PACKAGES_INCLUDE: 'PAYMENTS_PRICING_TABLE_SUBTITLE_ALL_PACKAGES_INCLUDE',
        INCLUDED_FEATURE_01: 'PAYMENTS_PRICING_TABLE_SUBTITLE_INCLUDED_FEATURE_01',
        INCLUDED_FEATURE_02: 'PAYMENTS_PRICING_TABLE_SUBTITLE_INCLUDED_FEATURE_02',
        INCLUDED_FEATURE_03: 'PAYMENTS_PRICING_TABLE_SUBTITLE_INCLUDED_FEATURE_03',
      },
      TEMP_TITLE: 'PAYMENTS_PRICING_TABLE_TEMP_TITLE',
      TOGGLE_BUTTON: {
        MONTHLY: 'PAYMENTS_PRICING_TABLE_TOGGLE_BUTTON_MONTHLY',
        YEARLY: 'PAYMENTS_PRICING_TABLE_TOGGLE_BUTTON_YEARLY',
      },
      FREE_PLAN_CTA: 'PAYMENTS_PRICING_TABLE_FREE_PLAN_CTA',
      PAID_PLAN_CTA: 'PAYMENTS_PRICING_TABLE_PAID_PLAN_CTA',
      PAID_ANNUAL_PLAN_CTA: 'PAYMENTS_PRICING_TABLE_PAID_ANNUAL_PLAN_CTA',
      DOWNGRADE_DATE_PREFIX: 'PAYMENTS_PRICING_TABLE_DOWNGRADE_DATE_PREFIX',
      RESTORE_PLAN: 'PAYMENTS_PRICING_TABLE_RESTORE_PLAN',
      RESTORE_CONFIRMATION_TITLE: 'PAYMENTS_PRICING_TABLE_RESTORE_CONFIRMATION_TITLE',
      CURRENT_PLAN_CTA: 'PAYMENTS_PRICING_TABLE_CURRENT_PLAN_CTA',
      UPGRADE_CTA: 'PAYMENTS_PRICING_TABLE_UPGRADE_CTA',
      CHANGE_PLAN_CTA: 'PAYMENTS_PRICING_TABLE_CHANGE_PLAN_CTA',
      CREDITS_TABLE_TITLE: 'PAYMENTS_PRICING_TABLE_CREDITS_TABLE_TITLE',
      PARTNERS_TITLE: 'PAYMENTS_PRICING_TABLE_PARTNERS_TITLE',
      FAQ_TITLE: 'PAYMENTS_PRICING_TABLE_FAQ_TITLE',
      COMING_SOON: 'PAYMENTS_PRICING_TABLE_COMING_SOON',
      MOST_POPULAR: 'PAYMENTS_PRICING_TABLE_MOST_POPULAR',
      GAIN_20_PERCENT: 'PAYMENTS_PRICING_TABLE_GAIN_20_PERCENT',
      FAQS: {
        FAQ_1: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_1_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_1_ANSWER',
        },
        FAQ_2: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_2_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_2_ANSWER',
        },
        FAQ_3: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_3_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_3_ANSWER',
        },
        FAQ_4: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_4_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_4_ANSWER',
        },
        FAQ_5: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_5_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_5_ANSWER',
        },
        FAQ_6: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_6_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_6_ANSWER',
        },
        FAQ_7: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_7_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_7_ANSWER',
        },
        FAQ_8: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_8_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_8_ANSWER',
        },
        FAQ_9: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_9_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_9_ANSWER',
        },
      },
    },
    CREDITS_SUCCESS_MESSAGE: 'PAYMENTS_CREDITS_SUCCESS_MESSAGE',
    UPGRADE_SUCCESS_MESSAGE: 'PAYMENTS_UPGRADE_SUCCESS_MESSAGE',
    DOWNGRADE_SUCCESS_MESSAGE: 'PAYMENTS_DOWNGRADE_SUCCESS_MESSAGE',
    UPGRADE_MODAL: {
      TITLE: 'PAYMENTS_UPGRADE_MODAL_TITLE',
      PROCESSING: 'PAYMENTS_UPGRADE_MODAL_PROCESSING',
      PLAN_DESCRIPTION: 'PAYMENTS_UPGRADE_MODAL_PLAN_DESCRIPTION',
      BILLING_CYCLE_INFO: 'PAYMENTS_UPGRADE_MODAL_BILLING_CYCLE_INFO',
      CHANGE_PAYMENT_METHOD: 'PAYMENTS_UPGRADE_MODAL_CHANGE_PAYMENT_METHOD',
      ERROR_MESSAGE: 'PAYMENTS_UPGRADE_MODAL_ERROR_MESSAGE',
      ERROR_MESSAGE_LINK: 'PAYMENTS_UPGRADE_MODAL_ERROR_MESSAGE_LINK',
      CTA_CONFIRM: 'PAYMENTS_UPGRADE_MODAL_CTA_CONFIRM',
      CTA_CANCEL: 'PAYMENTS_UPGRADE_MODAL_CTA_CANCEL',
    },
    DOWNGRADE_MODAL: {
      TITLE: 'PAYMENTS_DOWNGRADE_MODAL_TITLE',
      PLAN_CHANGE_MESSAGE: 'PAYMENTS_DOWNGRADE_MODAL_PLAN_CHANGE_MESSAGE',
      CTA_CONFIRM: 'PAYMENTS_DOWNGRADE_MODAL_CTA_CONFIRM',
      CTA_CANCEL: 'PAYMENTS_DOWNGRADE_MODAL_CTA_CANCEL',
    },
    GET_MORE_CREDITS_MODAL: {
      TITLE: 'PAYMENTS_GET_MORE_CREDITS_MODAL_TITLE',
      CTA_CONFIRM: 'PAYMENTS_GET_MORE_CREDITS_MODAL_CTA_CONFIRM',
      CTA_CANCEL: 'PAYMENTS_GET_MORE_CREDITS_MODAL_CTA_CANCEL',
      EQUALS: 'PAYMENTS_GET_MORE_CREDITS_MODAL_EQUALS',
      MIN_PRICE_ERROR: 'PAYMENTS_GET_MORE_CREDITS_MODAL_MIN_PRICE_ERROR',
    },
    CREDITS_OR_PRICING_MODAL: {
      TITLE: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_TITLE',
      SUBTITLE: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_SUBTITLE',
      CTA_CREDITS: {
        TITLE: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_CTA_CREDITS_TITLE',
        SUBTITLE: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_CTA_CREDITS_SUBTITLE',
      },
      CTA_PRICING: {
        TITLE: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_CTA_PRICING_TITLE',
        SUBTITLE: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_CTA_PRICING_SUBTITLE',
      },
      CTA_CONFIRM: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_CTA_CONFIRM',
      CTA_CANCEL: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_CTA_CANCEL',
    },
    TEAM_SIZE_MODAL: {
      TITLE: 'PAYMENTS_TEAM_SIZE_MODAL_TITLE',
      SUBTITLE: 'PAYMENTS_TEAM_SIZE_MODAL_SUBTITLE',
      CTA_CONFIRM: 'PAYMENTS_TEAM_SIZE_MODAL_CTA_CONFIRM',
    },
    ENTERPRISE_PACKAGE: {
      TITLE: 'PAYMENTS_ENTERPRISE_PACKAGE_TITLE',
      SUBTITLE: 'PAYMENTS_ENTERPRISE_PACKAGE_SUBTITLE',
      CTA: 'PAYMENTS_ENTERPRISE_PACKAGE_CTA',
      FEATURE_CUSTOM_CREDITS: 'PAYMENTS_ENTERPRISE_PACKAGE_FEATURE_CUSTOM_CREDITS',
      FEATURE_TEAM_TRAINING: 'PAYMENTS_ENTERPRISE_PACKAGE_FEATURE_TEAM_TRAINING',
      FEATURE_PREMIUM_SUPPORT: 'PAYMENTS_ENTERPRISE_PACKAGE_FEATURE_PREMIUM_SUPPORT',
      FEATURE_OWN_API_KEYS: 'PAYMENTS_ENTERPRISE_PACKAGE_FEATURE_OWN_API_KEYS',
      FEATURE_API_WORKFLOWS: 'PAYMENTS_ENTERPRISE_PACKAGE_FEATURE_API_WORKFLOWS',
    },
  },
  PRODUCT_TOURS: {
    FLOW: {
      GET_TO_KNOW_THE_INTERFACE_TOUR: {
        COMMUNITY_AND_MY_MODELS_CONTENT: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_COMMUNITY_AND_MY_MODELS_CONTENT',
        COMMUNITY_AND_MY_MODELS_TITLE: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_COMMUNITY_AND_MY_MODELS_TITLE',
        IMAGE_MODELS_CONTENT: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_IMAGE_MODELS_CONTENT',
        IMAGE_MODELS_TITLE: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_IMAGE_MODELS_TITLE',
        SIDE_MENU_CONTENT: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_SIDE_MENU_CONTENT',
        SIDE_MENU_TITLE: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_SIDE_MENU_TITLE',
        THREE_D_MODELS_CONTENT: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_THREE_D_MODELS_CONTENT',
        THREE_D_MODELS_TITLE: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_THREE_D_MODELS_TITLE',
        TOOLBOX_CONTENT: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_TOOLBOX_CONTENT',
        TOOLBOX_TITLE: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_TOOLBOX_TITLE',
        VIDEO_MODELS_CONTENT: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_VIDEO_MODELS_CONTENT',
        VIDEO_MODELS_TITLE: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_VIDEO_MODELS_TITLE',
        WELCOME_CONTENT: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_WELCOME_CONTENT',
        WELCOME_TITLE: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_WELCOME_TITLE',
      },
      NAVIGATION_TOUR: {
        ADD_NODES_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_ADD_NODES_CONTENT',
        ADD_NODES_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_ADD_NODES_TITLE',
        CHOOSE_PREFERENCE_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_CHOOSE_PREFERENCE_CONTENT',
        CHOOSE_PREFERENCE_CTA_MOUSE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_CHOOSE_PREFERENCE_CTA_MOUSE',
        CHOOSE_PREFERENCE_CTA_TRACKPAD: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_CHOOSE_PREFERENCE_CTA_TRACKPAD',
        CHOOSE_PREFERENCE_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_CHOOSE_PREFERENCE_TITLE',
        CONNECT_NODES_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_CONNECT_NODES_CONTENT',
        CONNECT_NODES_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_CONNECT_NODES_TITLE',
        DROP_NODE_HERE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_DROP_NODE_HERE',
        FINISH_TOUR_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_FINISH_TOUR_CONTENT',
        FINISH_TOUR_CTA_CONTINUE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_FINISH_TOUR_CTA_CONTINUE',
        FINISH_TOUR_CTA_STOP: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_FINISH_TOUR_CTA_STOP',
        FINISH_TOUR_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_FINISH_TOUR_TITLE',
        PAN_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_PAN_CONTENT',
        PAN_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_PAN_TITLE',
        RUN_MODEL_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_RUN_MODEL_CONTENT',
        RUN_MODEL_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_RUN_MODEL_TITLE',
        SHOW_NODE_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_SHOW_NODE_CONTENT',
        SHOW_NODE_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_SHOW_NODE_TITLE',
        WELCOME_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_WELCOME_CONTENT',
        WELCOME_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_WELCOME_TITLE',
        ZOOM_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_ZOOM_CONTENT',
        ZOOM_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_ZOOM_TITLE',
      },
    },
    NEXT_STEP: 'PRODUCT_TOURS_NEXT_STEP',
    PREVIOUS_STEP: 'PRODUCT_TOURS_PREVIOUS_STEP',
    QUIT_TOUR_CONFIRMATION_CANCEL: 'PRODUCT_TOURS_QUIT_TOUR_CONFIRMATION_CANCEL',
    QUIT_TOUR_CONFIRMATION_CTA: 'PRODUCT_TOURS_QUIT_TOUR_CONFIRMATION_CTA',
    QUIT_TOUR_CONFIRMATION_MESSAGE: 'PRODUCT_TOURS_QUIT_TOUR_CONFIRMATION_MESSAGE',
    QUIT_TOUR_CONFIRMATION_TITLE: 'PRODUCT_TOURS_QUIT_TOUR_CONFIRMATION_TITLE',
    START_OF_TOUR: {
      SKIP: 'PRODUCT_TOURS_START_OF_TOUR_SKIP',
      START_NOW: 'PRODUCT_TOURS_START_OF_TOUR_START_NOW',
    },
    TOUR_STEP_INDICATION: 'PRODUCT_TOURS_TOUR_STEP_INDICATION',
  },
  RECIPE_MAIN: {
    ERRORS: {
      NO_RECIPE_ACCESS: {
        TITLE: 'RECIPE_MAIN_ERRORS_NO_RECIPE_ACCESS_TITLE',
        DESCRIPTION: 'RECIPE_MAIN_ERRORS_NO_RECIPE_ACCESS_DESCRIPTION',
        ACTION: 'RECIPE_MAIN_ERRORS_NO_RECIPE_ACCESS_ACTION',
      },
      SAVE_ERRORS: {
        GENERAL: {
          MESSAGE: 'RECIPE_MAIN_ERRORS_SAVE_ERRORS_GENERAL_MESSAGE',
          ACTION: 'RECIPE_MAIN_ERRORS_SAVE_ERRORS_GENERAL_ACTION',
        },
        CONFLICT: {
          MESSAGE: 'RECIPE_MAIN_ERRORS_SAVE_ERRORS_CONFLICT_MESSAGE',
          ACTION: 'RECIPE_MAIN_ERRORS_SAVE_ERRORS_CONFLICT_ACTION',
        },
      },
      DOWNLOAD_FAILED: 'RECIPE_MAIN_ERRORS_DOWNLOAD_FAILED',
      DOWNLOAD_FAILED_MULTIPLE: 'RECIPE_MAIN_ERRORS_DOWNLOAD_FAILED_MULTIPLE',
      DOWNLOAD_SIZE_EXCEEDED: 'RECIPE_MAIN_ERRORS_DOWNLOAD_SIZE_EXCEEDED',
      CLEAR_CONTENT_FAILED: 'RECIPE_MAIN_ERRORS_CLEAR_CONTENT_FAILED',
    },
    DOWNLOAD_PREPARING: 'RECIPE_MAIN_DOWNLOAD_PREPARING',
    FLOW: {
      LEFT_TOOLS_PANEL: {
        MAIN_MENU: {
          BACK_TO_DASHBOARD: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_BACK_TO_DASHBOARD',
          CREATE_NEW_FILE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_CREATE_NEW_FILE',
          OPEN_RECENT: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_OPEN_RECENT',
          DUPLICATE_FILE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_DUPLICATE_FILE',
          USE_WHEEL_TO_ZOOM: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_USE_WHEEL_TO_ZOOM',
          RIGHT_CLICK_TO_OPEN_MENU: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_RIGHT_CLICK_TO_OPEN_MENU',
          REQUIRE_ALT_KEY_FOR_SUGGESTIONS:
            'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_REQUIRE_ALT_KEY_FOR_SUGGESTIONS',
          SHARE_WORKFLOW: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_SHARE_WORKFLOW',
          RENAME_WORKFLOW: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_RENAME_WORKFLOW',
          KEYBOARD_SHORTCUTS: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_KEYBOARD_SHORTCUTS',
          PREFERENCES: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_PREFERENCES',
          SNAP_TO_GRID: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_SNAP_TO_GRID',
          EDGE_STYLE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_EDGE_STYLE',
          EDGE_STYLE_BEZIER: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_EDGE_STYLE_BEZIER',
          EDGE_STYLE_STEP: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_EDGE_STYLE_STEP',
          EDGE_STYLE_LINE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_EDGE_STYLE_LINE',
          FILE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FILE',
          NEW_WEAVE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_NEW_WEAVE',
        },
        TITLE: {
          RECENT: 'RECENT',
          TOOLBOX: 'TOOLBOX',
          IMAGE: 'IMAGE',
          VIDEO: 'VIDEO',
          THREEDEE: 'THREEDEE',
          MY_MODELS: 'MY_MODELS',
          COMMUNITY_MODELS: 'COMMUNITY_MODELS',
          MEDIA: 'MEDIA',
        },
      },
      ACTIONS: {
        ZOOM_IN: 'ZOOM_IN',
        ZOOM_OUT: 'ZOOM_OUT',
        ZOOM_TO_HUNDRED: 'ZOOM_TO_HUNDRED',
        ZOOM_TO_FIT: 'ZOOM_TO_FIT',
        RUN_SELECTED: 'RUN_SELECTED',
      },
      WORKFLOW: 'WORKFLOW',
      DESIGN_APP: 'DESIGN_APP',
      CREDITS_INFO_CREDITS: 'CREDITS_INFO_CREDITS',
      SHARE: 'SHARE',
      CANNOT_DELETE_GROUP_WITH_LOCKED_NODES: 'RECIPE_MAIN_FLOW_CANNOT_DELETE_GROUP_WITH_LOCKED_NODES',
      APP_BUILDER_RIGHT_PANEL: {
        OUTPUTS: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_OUTPUTS',
        INPUTS: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_INPUTS',
        ADD_OUTPUT: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_ADD_OUTPUT',
        EMPTY_NO_OUTPUTS_LINE_1: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_EMPTY_NO_OUTPUTS_LINE_1',
        EMPTY_NO_OUTPUTS_LINE_2: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_EMPTY_NO_OUTPUTS_LINE_2',
      },
      APP_BUILDER_CANVAS: {
        SET_AS_OUTPUT: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_SET_AS_OUTPUT',
        OUTPUT_BADGE: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_OUTPUT_BADGE',
        REMOVE_OUTPUT_ARIA: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_REMOVE_OUTPUT_ARIA',
      },
      FLOW_NAVBAR: {
        DUPLICATE_TO_MY_FILES: 'DUPLICATE_TO_MY_FILES',
        READ_ONLY: 'READ_ONLY',
        SAVING: 'SAVING',
      },
      GALLERY: {
        DELETE_ALL_GENERATIONS: 'RECIPE_MAIN_GALLERY_DELETE_ALL_GENERATIONS',
        DELETE_ALL_OTHERS_GENERATIONS: 'RECIPE_MAIN_GALLERY_DELETE_ALL_OTHERS_GENERATIONS',
        DELETE_CURRENT_GENERATION: 'RECIPE_MAIN_GALLERY_DELETE_CURRENT_GENERATION',
        DOWNLOAD_CURRENT: 'RECIPE_MAIN_GALLERY_DOWNLOAD_CURRENT',
        DOWNLOAD_ALL: 'RECIPE_MAIN_GALLERY_DOWNLOAD_ALL',
        DOWNLOAD_BATCH: 'RECIPE_MAIN_GALLERY_DOWNLOAD_BATCH',
        OPEN_IN_GALLERY: 'RECIPE_MAIN_GALLERY_OPEN_IN_GALLERY',
        PARAMS: {
          HIDE_INFO: 'HIDE_INFO',
          NO_PREVIEW: 'NO_PREVIEW',
          NEGATIVE_PROMPT: 'NEGATIVE_PROMPT',
          MODEL: 'MODEL',
          PARAMETERS: 'PARAMETERS',
          PROMPT: 'PROMPT',
          SHOW_INFO: 'SHOW_INFO',
          SHOW_MORE: 'SHOW_MORE',
          SHOW_LESS: 'SHOW_LESS',
          REFERENCE_IMAGE: 'REFERENCE_IMAGE',
        },
        SET_AS_COVER: 'RECIPE_MAIN_GALLERY_SET_AS_COVER',
      },
      GROUP: {
        DELETE_GROUP_CONFIRMATION: {
          TITLE_SINGLE: 'RECIPE_MAIN_FLOW_GROUP_DELETE_GROUP_CONFIRMATION_TITLE_SINGLE',
          TITLE_PLURAL: 'RECIPE_MAIN_FLOW_GROUP_DELETE_GROUP_CONFIRMATION_TITLE_PLURAL',
          MESSAGE_SINGLE: 'RECIPE_MAIN_FLOW_GROUP_DELETE_GROUP_CONFIRMATION_MESSAGE_SINGLE',
          MESSAGE_PLURAL: 'RECIPE_MAIN_FLOW_GROUP_DELETE_GROUP_CONFIRMATION_MESSAGE_PLURAL',
          CTA_CONFIRM: 'RECIPE_MAIN_FLOW_GROUP_DELETE_GROUP_CONFIRMATION_CTA_CONFIRM',
          CTA_CANCEL: 'RECIPE_MAIN_FLOW_GROUP_DELETE_GROUP_CONFIRMATION_CTA_CANCEL',
          CHECKBOX_LABEL: 'RECIPE_MAIN_FLOW_GROUP_DELETE_GROUP_CONFIRMATION_CHECKBOX_LABEL',
        },
      },
      GENERAL: {
        READ_ONLY_PANEL: {
          CTA_EDITOR: 'READ_ONLY_PANEL_CTA_EDITOR',
          CTA_READER: 'READ_ONLY_PANEL_CTA_READER',
          CTA_GUEST: 'READ_ONLY_PANEL_CTA_GUEST',
          TITLE_EDITOR: 'READ_ONLY_PANEL_TITLE_EDITOR',
          TITLE_READER: 'READ_ONLY_PANEL_TITLE_READER',
        },
      },
      LEFT_PANEL: {
        MEDIA_LIBRARY: {
          NO_MEDIA: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MEDIA_LIBRARY_NO_MEDIA',
        },
        MODELS: {
          COMMUNITY_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MODELS_COMMUNITY_MODELS',
          MY_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MODELS_MY_MODELS',
        },
        TOOLBOX: {
          MOST_USED: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_MOST_USED',
        },
        MENU_TITLES: {
          RECENT: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_RECENT',
          TOOLS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_TOOLS',
          IMAGE_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_IMAGE_MODELS',
          VIDEO_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_VIDEO_MODELS',
          THREE_D_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_THREE_D_MODELS',
          CUSTOM_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_CUSTOM_MODELS',
          FREQUENTLY_USED: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_FREQUENTLY_USED',
          DATA_TYPES: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_DATATYPES',
          NON_MODEL_EDIT: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_EDITING',
          ITERATORS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_ITERATORS',
          HELPERS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_HELPERS',
          TEXT_TOOLS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_TEXT_TOOLS',
          GENERATE_IMAGE_FROM_TEXT: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_GENERATE_IMAGE_FROM_TEXT',
          MATTING: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_MATTING_TOOLS',
          LIP_SYNC: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_LIP_SYNC',
          GENERATE_VECTOR_FROM_TEXT: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_GENERATE_VECTOR_FROM_TEXT',
          EDIT_IMAGE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_EDIT_IMAGE',
          GENERATE_IMAGE_FROM_IMAGE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_GENERATE_IMAGE_FROM_IMAGE',
          ENHANCE_IMAGE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_ENHANCE_IMAGE',
          GENERATE_VIDEO_FROM_TEXT_OR_IMAGE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_GENERATE_VIDEO_FROM_TEXT_OR_IMAGE',
          GENERATE_VIDEO_FROM_VIDEO: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_GENERATE_VIDEO_FROM_VIDEO',
          ENHANCE_VIDEO: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_ENHANCE_VIDEO',
          GENERATE_3D_FROM_TEXT_OR_IMAGE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_GENERATE_3D_FROM_TEXT_OR_IMAGE',
          USER_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_USER_MODELS',
          COMMUNITY_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_COMMUNITY_MODELS',
          SAVED: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_SAVED',
          SAVED_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_SAVED_MODELS',
          SAVED_NODES: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_SAVED_NODES',
        },
        SEARCH: {
          EMPTY: 'RECIPE_MAIN_FLOW_LEFT_PANEL_SEARCH_EMPTY',
        },
        NEW_INDICATOR: 'RECIPE_MAIN_FLOW_LEFT_PANEL_NEW_INDICATOR',
        NODE_DETAILS: {
          VERIFIED_BY_FIGMA: 'RECIPE_MAIN_FLOW_LEFT_PANEL_NODE_DETAILS_VERIFIED_BY_FIGMA',
          UNVERIFIED_DISCLAIMER_WITH_ADDITIONAL_TERMS:
            'RECIPE_MAIN_FLOW_LEFT_PANEL_NODE_DETAILS_UNVERIFIED_DISCLAIMER_WITH_ADDITIONAL_TERMS',
          UNVERIFIED_DISCLAIMER: 'RECIPE_MAIN_FLOW_LEFT_PANEL_NODE_DETAILS_UNVERIFIED_DISCLAIMER',
          BASED_ON: 'RECIPE_MAIN_FLOW_LEFT_PANEL_NODE_DETAILS_BASED_ON',
          CREATED_BY: 'RECIPE_MAIN_FLOW_LEFT_PANEL_NODE_DETAILS_CREATED_BY',
          CREATED_BY_ME: 'RECIPE_MAIN_FLOW_LEFT_PANEL_NODE_DETAILS_CREATED_BY_ME',
        },
        ITERATOR_MENU_ITEMS: {
          TEXT_ITERATOR: {
            DISPLAY_NAME: 'RECIPE_MAIN_FLOW_LEFT_PANEL_ITERATOR_MENU_ITEMS_TEXT_ITERATOR_DISPLAY_NAME',
            DESCRIPTION: 'RECIPE_MAIN_FLOW_LEFT_PANEL_ITERATOR_MENU_ITEMS_TEXT_ITERATOR_DESCRIPTION',
          },
          IMAGE_ITERATOR: {
            DISPLAY_NAME: 'RECIPE_MAIN_FLOW_LEFT_PANEL_ITERATOR_MENU_ITEMS_IMAGE_ITERATOR_DISPLAY_NAME',
            DESCRIPTION: 'RECIPE_MAIN_FLOW_LEFT_PANEL_ITERATOR_MENU_ITEMS_IMAGE_ITERATOR_DESCRIPTION',
          },
          VIDEO_ITERATOR: {
            DISPLAY_NAME: 'RECIPE_MAIN_FLOW_LEFT_PANEL_ITERATOR_MENU_ITEMS_VIDEO_ITERATOR_DISPLAY_NAME',
            DESCRIPTION: 'RECIPE_MAIN_FLOW_LEFT_PANEL_ITERATOR_MENU_ITEMS_VIDEO_ITERATOR_DESCRIPTION',
          },
          BLEND: {
            DESCRIPTION: 'RECIPE_MAIN_FLOW_LEFT_PANEL_ITERATOR_MENU_ITEMS_BLEND_DESCRIPTION',
          },
        },
        WORKSPACE_ASSETS: {
          TITLE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_TITLE',
          MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_MODELS',
          NODES: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_NODES',
          SUBFLOWS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_SUBFLOWS',
          COMING_SOON: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_COMING_SOON',
          NODES_EMPTY: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_NODES_EMPTY',
          MODELS_EMPTY: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_MODELS_EMPTY',
          EDIT_TOOLTIP: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EDIT_TOOLTIP',
          DONE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DONE',
          EDIT_DIALOG_TITLE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EDIT_DIALOG_TITLE',
          EDIT_SAVE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EDIT_SAVE',
          EDIT_SUCCESS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EDIT_SUCCESS',
          EDIT_ERROR: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EDIT_ERROR',
          DELETE_TITLE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_TITLE',
          DELETE_MESSAGE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_MESSAGE',
          DELETE_CONFIRM: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_CONFIRM',
          DELETE_DONT_SHOW: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_DONT_SHOW',
          DELETE_MODEL_SUCCESS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_MODEL_SUCCESS',
          DELETE_NODE_SUCCESS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_NODE_SUCCESS',
          DELETE_MODEL_ERROR: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_MODEL_ERROR',
          DELETE_NODE_ERROR: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_NODE_ERROR',
          NOT_OWNER_TOOLTIP: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_NOT_OWNER_TOOLTIP',
        },
        FILTERS: {
          ORDERBY: {
            LABEL: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_ORDERBY_LABEL',
            FEATURED: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_ORDERBY_FEATURED',
            PRICE_ASC: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_ORDERBY_PRICE_ASC',
            PRICE_DESC: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_ORDERBY_PRICE_DESC',
          },
          MODE_TOGGLE: {
            ALL: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_MODE_TOGGLE_ALL',
            TOOLS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_MODE_TOGGLE_TOOLS',
            MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_MODE_TOGGLE_MODELS',
            VERIFIED: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_MODE_TOGGLE_VERIFIED',
            UNVERIFIED: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_MODE_TOGGLE_UNVERIFIED',
          },
        },
      },
      DRAWER: {
        MODEL_PROPERTIES: {
          BYOK_LABEL: 'RECIPE_MAIN_FLOW_DRAWER_MODEL_PROPERTIES_BYOK_LABEL',
          BYOK_TOOLTIP: 'RECIPE_MAIN_FLOW_DRAWER_MODEL_PROPERTIES_BYOK_TOOLTIP',
          NUM_OF_MODELS: 'RECIPE_MAIN_FLOW_DRAWER_MODEL_PROPERTIES_NUM_OF_MODELS',
          SET_AS_INPUT: 'RECIPE_MAIN_FLOW_DRAWER_MODEL_PROPERTIES_SET_AS_INPUT',
          SET_AS_PARAMETER: 'RECIPE_MAIN_FLOW_DRAWER_MODEL_PROPERTIES_SET_AS_PARAMETER',
          ADD_LIST_ITEM: 'RECIPE_MAIN_FLOW_DRAWER_MODEL_PROPERTIES_ADD_LIST_ITEM',
          LIST_ITEM_PLACEHOLDER: 'RECIPE_MAIN_FLOW_DRAWER_MODEL_PROPERTIES_LIST_ITEM_PLACEHOLDER',
        },
        RUN_MODELS_SECTION: {
          TITLE: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_TITLE',
          RUNS: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_RUNS',
          CTA: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_CTA',
          UNSUPPORTED_NODES_INFO: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_UNSUPPORTED_NODES_INFO',
          ALREADY_RUNNING_INFO: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_ALREADY_RUNNING_INFO',
          NOT_ENOUGH_CREDITS: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_NOT_ENOUGH_CREDITS',
          NOT_ENOUGH_CREDITS_INDIVIDUAL: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_NOT_ENOUGH_CREDITS_INDIVIDUAL',
          NOT_ENOUGH_CREDITS_TEAM: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_NOT_ENOUGH_CREDITS_TEAM',
          ITERATORS_INFO: {
            TITLE: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_ITERATORS_INFO_TITLE',
          },
        },
      },
      SUGGESTION_MENU: {
        DROP_INDICATION: 'RECIPE_MAIN_FLOW_SUGGESTION_MENU_DROP_INDICATION',
      },
      PRICY_MODEL_MODAL: {
        TITLE: 'RECIPE_MAIN_FLOW_PRICY_MODEL_MODAL_TITLE',
        SUBTITLE: 'RECIPE_MAIN_FLOW_PRICY_MODEL_MODAL_SUBTITLE',
        CHECKBOX_LABEL: 'RECIPE_MAIN_FLOW_PRICY_MODEL_MODAL_CHECKBOX_LABEL',
        MODEL_NAME_PLACEHOLDER: 'RECIPE_MAIN_FLOW_PRICY_MODEL_MODAL_MODEL_NAME_PLACEHOLDER',
        CTA_CONFIRM: 'RECIPE_MAIN_FLOW_PRICY_MODEL_MODAL_CTA_CONFIRM',
        CTA_CANCEL: 'RECIPE_MAIN_FLOW_PRICY_MODEL_MODAL_CTA_CANCEL',
      },
      UNKNOWN_COST: {
        DIALOG: {
          TITLE: 'RECIPE_MAIN_FLOW_UNKNOWN_COST_DIALOG_TITLE',
          MSG: 'RECIPE_MAIN_FLOW_UNKNOWN_COST_DIALOG_MSG',
          CONFIRM_BTN_TEXT: 'RECIPE_MAIN_FLOW_UNKNOWN_COST_DIALOG_CONFIRM_BTN_TEXT',
        },
        PRICE_TEXT: 'RECIPE_MAIN_FLOW_UNKNOWN_COST_TEXT',
        TOOLTIP: 'RECIPE_MAIN_FLOW_UNKNOWN_COST_TOOLTIP',
      },
      ITERATORS_SECTION: {
        VALUES: 'RECIPE_MAIN_FLOW_ITERATORS_SECTION_VALUES',
      },
      UNVERIFIED_MODEL_RUN: {
        DIALOG: {
          TITLE: 'RECIPE_MAIN_FLOW_UNVERIFIED_MODEL_RUN_DIALOG_TITLE',
          TEXT: 'RECIPE_MAIN_FLOW_UNVERIFIED_MODEL_RUN_DIALOG_TEXT',
        },
        DIALOG_IMPORTED_MODEL: {
          TITLE: 'RECIPE_MAIN_FLOW_UNVERIFIED_MODEL_RUN_DIALOG_IMPORTED_MODEL_TITLE',
        },
      },
      CLEAR_ALL_CONTENT_CONFIRMATION: {
        TITLE: 'RECIPE_MAIN_FLOW_CLEAR_ALL_CONTENT_CONFIRMATION_TITLE',
        MESSAGE: 'RECIPE_MAIN_FLOW_CLEAR_ALL_CONTENT_CONFIRMATION_MESSAGE',
        CHECKBOX_LABEL: 'RECIPE_MAIN_FLOW_CLEAR_ALL_CONTENT_CONFIRMATION_CHECKBOX_LABEL',
      },
      CLEAR_OTHER_CONTENT_CONFIRMATION: {
        TITLE: 'RECIPE_MAIN_FLOW_CLEAR_OTHER_CONTENT_CONFIRMATION_TITLE',
        MESSAGE: 'RECIPE_MAIN_FLOW_CLEAR_OTHER_CONTENT_CONFIRMATION_MESSAGE',
        CHECKBOX_LABEL: 'RECIPE_MAIN_FLOW_CLEAR_OTHER_CONTENT_CONFIRMATION_CHECKBOX_LABEL',
      },
    },
    NODES: {
      DEPRECATED: {
        GENERAL: 'GENERAL_DEPRECATION_MESSAGE',
        EDIT: 'EDIT_DEPRECATION_MESSAGE',
        COMPV2: 'COMPOSITOR_V2_DEPRECATION_MESSAGE',
      },
      SHARED: {
        NODE_DETAILS_ACCORDION: {
          TITLE: 'RECIPE_MAIN_NODES_SHARED_NODE_DETAILS_ACCORDION_TITLE',
        },
        SHOW_MORE_CHIP: {
          SHOW_MORE: 'RECIPE_MAIN_NODES_SHARED_SHOW_MORE_CHIP_SHOW_MORE',
          SHOW_LESS: 'RECIPE_MAIN_NODES_SHARED_SHOW_MORE_CHIP_SHOW_LESS',
        },
      },
      EXPORT: {
        EXPORT_CTA: 'EXPORT',
        EXPORT_CTA_RENDERING: 'RENDERING',
      },
      LOCKED: {
        CLICK_TO_UNLOCK: 'CLICK_TO_UNLOCK',
        CLICK_TO_UNLOCK_GROUP: 'CLICK_TO_UNLOCK_GROUP',
        THIS_NODE_IS_LOCKED: 'THIS_NODE_IS_LOCKED',
        THIS_NODE_IS_LOCKED_GROUP: 'THIS_NODE_IS_LOCKED_GROUP',
      },
      MULTI_LORA: {
        ADD_LORA: 'ADD_LORA',
        LORAS: 'LORAS',
        SELECT_LORA: 'SELECT_LORA',
        NO_OPTIONS: 'NO_OPTIONS',
      },
      NODE_MENU: {
        DELETE: 'DELETE',
        DELETE_ALL_UPLOADS: 'DELETE_ALL_UPLOADS',
        DELETE_ALL_OTHERS_UPLOADS: 'DELETE_ALL_OTHERS_UPLOADS',
        DELETE_CURRENT_UPLOAD: 'DELETE_CURRENT_UPLOAD',
        DUPLICATE: 'DUPLICATE',
        LOCK: 'LOCK',
        RENAME: 'RENAME',
        UNLOCK: 'UNLOCK',
        UNLOCK_GROUP_FIRST: 'UNLOCK_GROUP_FIRST',
        REMOVE_FROM_GROUP: 'REMOVE_FROM_GROUP',
        VIEW_MODE: 'VIEW_MODE',
        VIEW_MODE_SINGLE: 'VIEW_MODE_SINGLE',
        VIEW_MODE_BATCH: 'VIEW_MODE_BATCH',
        VIEW_MODE_ALL: 'VIEW_MODE_ALL',
        SAVE_NODE: 'SAVE_NODE',
        SAVE_NODE_SUCCESS: 'SAVE_NODE_SUCCESS',
        SAVE_NODE_ERROR: 'SAVE_NODE_ERROR',
        SAVE_MODEL: 'SAVE_MODEL',
        SAVE_MODEL_SUCCESS: 'SAVE_MODEL_SUCCESS',
        SAVE_MODEL_ERROR: 'SAVE_MODEL_ERROR',
        UNPACK: 'NODE_MENU_UNPACK',
        CREATE_ITERATOR: 'NODE_MENU_CREATE_ITERATOR',
        CREATE_IMAGE_ITERATOR: 'NODE_MENU_CREATE_IMAGE_ITERATOR',
        CREATE_VIDEO_ITERATOR: 'NODE_MENU_CREATE_VIDEO_ITERATOR',
        CREATE_TEXT_ITERATOR: 'NODE_MENU_CREATE_TEXT_ITERATOR',
      },
      NODE_MENU_CONFIRMATION_DIALOG: {
        CANCEL_TEXT: 'NODE_MENU_CONFIRMATION_DIALOG_CANCEL_TEXT',
        CONFIRM_TEXT: 'NODE_MENU_CONFIRMATION_DIALOG_CONFIRM_TEXT',
        MESSAGE: 'NODE_MENU_CONFIRMATION_DIALOG_MESSAGE',
        DELETE_ALL_UPLOADS_MESSAGE: 'NODE_MENU_CONFIRMATION_DIALOG_DELETE_ALL_UPLOADS_MESSAGE',
      },
      PROMPT_CONCAT: {
        ADDITIONAL_TEXT_PLACEHOLDER: 'PROMPT_CONCAT_ADDITIONAL_TEXT_PLACEHOLDER',
        PLACEHOLDER: 'PROMPT_CONCAT_PLACEHOLDER',
        ADD_ANOTHER_TEXT_INPUT: 'PROMPT_CONCAT_ADD_ANOTHER_TEXT_INPUT',
      },
      PROMPT_NODE_V2: {
        PROMPT_LABEL: 'PROMPT_NODE_V2_PROMPT_LABEL',
        NEGATIVE_PROMPT_LABEL: 'PROMPT_NODE_V2_NEGATIVE_PROMPT_LABEL',
        PLACEHOLDER: 'PROMPT_NODE_V2_PLACEHOLDER',
        NEGATIVE_PROMPT_PLACEHOLDER: 'PROMPT_NODE_V2_NEGATIVE_PROMPT_PLACEHOLDER',
      },
      PROMPT_NODE_V3: {
        DISPLAY_MODE: 'PROMPT_NODE_V3_DISPLAY_MODE',
        PLACEHOLDER: 'PROMPT_NODE_V3_PLACEHOLDER',
        TRUNCATED_WARNING: 'PROMPT_NODE_V3_TRUNCATED_WARNING',
        ADD_VARIABLE: 'PROMPT_NODE_V3_ADD_VARIABLE',
        CREATE_VARIABLE: 'PROMPT_NODE_V3_CREATE_VARIABLE',
        DISPLAY_SOURCE_VALUE: 'PROMPT_NODE_V3_DISPLAY_SOURCE_VALUE',
        DISPLAY_VALUE: 'PROMPT_NODE_V3_DISPLAY_VALUE',
        DISPLAY_SOURCE: 'PROMPT_NODE_V3_DISPLAY_SOURCE',
        TAG_CONTEXT_MENU: {
          DUPLICATE: 'PROMPT_NODE_V3_TAG_CONTEXT_MENU_DUPLICATE',
          DELETE: 'PROMPT_NODE_V3_TAG_CONTEXT_MENU_DELETE',
        },
        EDITOR_CONTEXT_MENU: {
          PASTE: 'PROMPT_NODE_V3_EDITOR_CONTEXT_MENU_PASTE',
        },
      },
      STICKY_NOTE: {
        PLACEHOLDER: 'STICKY_NOTE_PLACEHOLDER',
        CONTEXT_MENU: {
          FONT_SIZE: 'STICKY_NOTE_FONT_SIZE',
          FONT_SIZE_OPTIONS: {
            SMALL: 'STICKY_NOTE_FONT_SIZE_OPTIONS_SMALL',
            MEDIUM: 'STICKY_NOTE_FONT_SIZE_OPTIONS_MEDIUM',
            LARGE: 'STICKY_NOTE_FONT_SIZE_OPTIONS_LARGE',
          },
        },
      },
      WILDCARD: {
        PLACEHOLDER: 'WILDCARD_PLACEHOLDER',
        PLACEHOLDER_TEMP: 'WILDCARD_PLACEHOLDER_TEMP',
        INPUT_ERROR: 'WILDCARD_INPUT_ERROR',
        SAVE_TO_MY_LIBRARY_CTA: 'SAVE_TO_MY_LIBRARY_CTA',
        ADDED_TO_MY_LIBRARY: 'ADDED_TO_MY_LIBRARY',
        SAVE_TO_MY_LIBRARY_DIALOG: {
          TITLE: 'SAVE_TO_MY_LIBRARY_DIALOG_TITLE',
          SUBTITLE: 'SAVE_TO_MY_LIBRARY_DIALOG_SUBTITLE',
          NAME_LABEL: 'SAVE_TO_MY_LIBRARY_DIALOG_NAME_LABEL',
          NAME_PLACEHOLDER: 'SAVE_TO_MY_LIBRARY_DIALOG_NAME_PLACEHOLDER',
          DESCRIPTION_LABEL: 'SAVE_TO_MY_LIBRARY_DIALOG_DESCRIPTION_LABEL',
          DESCRIPTION_PLACEHOLDER: 'SAVE_TO_MY_LIBRARY_DIALOG_DESCRIPTION_PLACEHOLDER',
          CTA_SAVE: 'SAVE_TO_MY_LIBRARY_DIALOG_CTA_SAVE',
          CTA_CANCEL: 'SAVE_TO_MY_LIBRARY_DIALOG_CTA_CANCEL',
        },
      },
      COMPOSITOR: {
        EDIT_CTA: 'COMPOSITOR_EDIT_CTA',
        ADD_ANOTHER_LAYER_CTA: 'COMPOSITOR_ADD_ANOTHER_LAYER_CTA',
      },
      PAINTER: {
        BACKGROUND_COLOR_LABEL: 'PAINTER_BACKGROUND_COLOR_LABEL',
        BRUSH_SIZE_LABEL: 'PAINTER_BRUSH_SIZE_LABEL',
      },
      CROP: {
        DIMENSIONS: 'CROP_DIMENSIONS',
        ASPECT_RATIO: 'CROP_ASPECT_RATIO',
        LOCK_ASPECT_RATIO: 'CROP_LOCK_ASPECT_RATIO',
        CUSTOM_ASPECT_RATIO: 'CROP_CUSTOM_ASPECT_RATIO',
        WIDTH_LETTER: 'CROP_WIDTH_LETTER',
        HEIGHT_LETTER: 'CROP_HEIGHT_LETTER',
        RESET: 'CROP_RESET',
      },
      RESIZE: {
        UNSUPPORTED_FILE: 'RESIZE_UNSUPPORTED_FILE',
      },
      NUMBER: {
        IS_FLOAT: 'NUMBER_IS_FLOAT',
        MIN: 'NUMBER_MIN',
        MAX: 'NUMBER_MAX',
      },
      ARRAY: {
        ADD_ITEM: 'ARRAY_ADD_ITEM',
        SPLIT_TEXT_BY: 'ARRAY_SPLIT_TEXT_BY',
        PLACEHOLDER: 'ARRAY_PLACEHOLDER',
        ITEMS_COUNT: 'ARRAY_ITEMS_COUNT',
      },
      TOGGLE: {
        TRUE: 'RECIPE_MAIN_NODES_TOGGLE_TRUE',
        FALSE: 'RECIPE_MAIN_NODES_TOGGLE_FALSE',
      },
      MASKS: {
        IMAGE: 'MASKS_IMAGE',
        MASK: 'MASKS_MASK',
        ERROR: 'MASKS_ERROR',
        RECALCULATE_MASK: 'MASKS_RECALCULATE_MASK',
      },
      CHANNEL: {
        RED: 'RECIPE_MAIN_NODES_CHANNEL_RED',
        GREEN: 'RECIPE_MAIN_NODES_CHANNEL_GREEN',
        BLUE: 'RECIPE_MAIN_NODES_CHANNEL_BLUE',
        ALPHA: 'RECIPE_MAIN_NODES_CHANNEL_ALPHA',
      },
      BLUR: {
        SIZE: 'RECIPE_MAIN_NODES_BLUR_SIZE',
        TYPE: 'RECIPE_MAIN_NODES_BLUR_TYPE',
        BOX: 'RECIPE_MAIN_NODES_BLUR_BOX',
        GAUSSIAN: 'RECIPE_MAIN_NODES_BLUR_GAUSSIAN',
      },
      EXTRACT_VIDEO_FRAME: {
        TIMECODE: 'RECIPE_MAIN_NODES_EXTRACT_VIDEO_FRAME_TIMECODE',
        FRAME: 'RECIPE_MAIN_NODES_EXTRACT_VIDEO_FRAME_FRAME',
      },
      LIST_NODE: {
        SELECT_AN_OPTION: 'RECIPE_MAIN_NODES_LIST_NODE_SELECT_AN_OPTION',
        ADD_OPTIONS_VIA_PROPERTIES_PANEL: 'RECIPE_MAIN_NODES_LIST_NODE_ADD_OPTIONS_VIA_PROPERTIES_PANEL',
        ITERATOR: {
          PLACEHOLDER: 'RECIPE_MAIN_NODES_LIST_NODE_ITERATOR_PLACEHOLDER',
          ADD_ITEM: 'RECIPE_MAIN_NODES_LIST_NODE_ITERATOR_ADD_ITEM',
          ITEMS_COUNT: 'RECIPE_MAIN_NODES_LIST_NODE_ITERATOR_ITEMS_COUNT',
        },
        OPTIONS_LABEL: 'RECIPE_MAIN_NODES_LIST_NODE_OPTIONS_LABEL',
        OPTIONS_TOOLTIP: 'RECIPE_MAIN_NODES_LIST_NODE_OPTIONS_TOOLTIP',
      },
      PREVIEW_NODE: {
        SET_AS_COVER: 'RECIPE_MAIN_NODES_PREVIEW_NODE_SET_AS_COVER',
      },
      LEVELS: {
        CHANNEL: 'RECIPE_MAIN_NODES_LEVELS_CHANNEL',
        RESET: 'RECIPE_MAIN_NODES_LEVELS_RESET',
        INPUTS: 'RECIPE_MAIN_NODES_LEVELS_INPUTS',
        HISTOGRAM: 'RECIPE_MAIN_NODES_LEVELS_HISTOGRAM',
        RED: 'RECIPE_MAIN_NODES_LEVELS_RED',
        GREEN: 'RECIPE_MAIN_NODES_LEVELS_GREEN',
        BLUE: 'RECIPE_MAIN_NODES_LEVELS_BLUE',
        NO_HISTOGRAM_DATA: 'RECIPE_MAIN_NODES_LEVELS_NO_HISTOGRAM_DATA',
      },
      DILATION_EROSION: {
        SIZE: 'RECIPE_MAIN_NODES_DILATION_EROSION_SIZE',
      },
      MODEL_BASE_NODE: {
        LEARN_MORE_ABOUT_THIS_MODEL: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_LEARN_MORE_ABOUT_THIS_MODEL',
        LLM_EDITED: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_LLM_EDITED',
        MODEL_NODE_FOOTER: {
          ADVANCED_OPTIONS: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADVANCED_OPTIONS',
          ADD_ANOTHER_IMAGE_INPUT: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_ANOTHER_IMAGE_INPUT',
          ADD_ANOTHER_INPUT: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_ANOTHER_INPUT',
          ADD_ANOTHER_VIDEO_INPUT: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_ANOTHER_VIDEO_INPUT',
          ADD_ANOTHER_IMAGE_INPUT_DISABLED:
            'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_ANOTHER_IMAGE_INPUT_DISABLED',
          ADD_INPUT_LIMIT_TYPE_ELEMENT:
            'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_INPUT_LIMIT_TYPE_ELEMENT',
          ADD_INPUT_LIMIT_TYPE_REFERENCE_IMAGE:
            'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_INPUT_LIMIT_TYPE_REFERENCE_IMAGE',
          ADD_INPUT_LIMIT_TYPE_INPUT: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_INPUT_LIMIT_TYPE_INPUT',
          ADD_ANOTHER_LORA: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_ANOTHER_LORA',
          ADD_ELEMENT: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_ELEMENT',
          ERROR_REQUIRED: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ERROR_REQUIRED',
          CREDITS_MESSAGE: {
            LOW_CREDITS_MESSAGE:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_LOW_CREDITS_MESSAGE',
            LOW_CREDITS_MESSAGE_SHORT:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_LOW_CREDITS_MESSAGE_SHORT',
            LOW_CREDITS_MESSAGE_PART_2_FREE:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_LOW_CREDITS_MESSAGE_PART_2_FREE',
            LOW_CREDITS_MESSAGE_PART_2_GET_MORE_CREDITS_CTA:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_LOW_CREDITS_MESSAGE_PART_2_GET_MORE_CREDITS',
            LOW_CREDITS_MESSAGE_OR:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_LOW_CREDITS_MESSAGE_OR',
            LOW_CREDITS_MESSAGE_PART_3_UPGRADE_CTA:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_LOW_CREDITS_MESSAGE_PART_3_UPGRADE',
            LOW_CREDITS_MESSAGE_PART_2_MEMBER:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_LOW_CREDITS_MESSAGE_PART_2_MEMBER',
            FREE_TIER_MESSAGE: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_FREE_TIER_MESSAGE',
            STARTER_PRO_MESSAGE:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_STARTER_PRO_MESSAGE',
            TEAM_ENTERPRISE_MEMBER_MESSAGE:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_TEAM_ENTERPRISE_MEMBER_MESSAGE',
            TEAM_ENTERPRISE_ADMIN_MESSAGE:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_TEAM_ENTERPRISE_ADMIN_MESSAGE',
          },
          MODEL_NOT_SUPPORTED: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_MODEL_NOT_SUPPORTED',
          ERROR_MODEL_RUN: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ERROR_MODEL_RUN',
          NANO_BANANA_PRO_INTERMITTENT_ISSUES:
            'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_NANO_BANANA_PRO_INTERMITTENT_ISSUES',
        },
        TEXT_MODEL: {
          EMPTY_STATE_PLACEHOLDER: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_TEXT_MODEL_EMPTY_STATE_PLACEHOLDER',
        },
        RUN_MODEL_BUTTON: {
          RUN: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_RUN',
          RUNNING: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_RUNNING',
          CANCEL_RUN: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_CANCEL_RUN',
          CANCELLING: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_CANCELLING',
          INITIALIZING: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_INITIALIZING',
        },
        OVERLAY: {
          BATCH: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_OVERLAY_BATCH',
        },
      },
      SEED: {
        RANDOM: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_SEED_RANDOM',
      },
      NODE_HANDLES: {
        ILLEGAL_TYPE_CONNECTION: 'RECIPE_MAIN_NODES_NODE_HANDLES_ILLEGAL_TYPE_CONNECTION',
        REQUIRED_VALIDATION_ERROR: 'RECIPE_MAIN_NODES_NODE_HANDLES_REQUIRED_VALIDATION_ERROR',
        CYCLIC_CONNECTION: 'RECIPE_MAIN_NODES_NODE_HANDLES_CYCLIC_CONNECTION',
        EMPTY_REQUIRED_VALIDATION_ERROR: 'RECIPE_MAIN_NODES_NODE_HANDLES_EMPTY_REQUIRED_VALIDATION_ERROR',
      },
      IMPORT_NODE: {
        UPLOAD_ERROR_INVALID_FILE_TYPE: 'RECIPE_MAIN_NODES_IMPORT_NODE_UPLOAD_ERROR_INVALID_FILE_TYPE',
        UPLOAD_ERROR_INVALID_FILE_TYPE_GENERIC: 'RECIPE_MAIN_NODES_IMPORT_NODE_UPLOAD_ERROR_INVALID_FILE_TYPE_GENERIC',
        ADD_MORE_IMAGES: 'RECIPE_MAIN_NODES_IMPORT_NODE_ADD_MORE_IMAGES',
        ADD_MORE_VIDEOS: 'RECIPE_MAIN_NODES_IMPORT_NODE_ADD_MORE_VIDEOS',
        ADD_MORE_AUDIO: 'RECIPE_MAIN_NODES_IMPORT_NODE_ADD_MORE_AUDIO',
        ADD_MORE_3D_FILES: 'RECIPE_MAIN_NODES_IMPORT_NODE_ADD_MORE_3D_FILES',
        ADD_MORE_FILES: 'RECIPE_MAIN_NODES_IMPORT_NODE_ADD_MORE_FILES',
        IMAGES: 'RECIPE_MAIN_NODES_IMPORT_NODE_IMAGES',
        VIDEOS: 'RECIPE_MAIN_NODES_IMPORT_NODE_VIDEOS',
        AUDIO: 'RECIPE_MAIN_NODES_IMPORT_NODE_AUDIO',
        TEXT: 'RECIPE_MAIN_NODES_IMPORT_NODE_TEXT',
        THREE_D_FILES: 'RECIPE_MAIN_NODES_IMPORT_NODE_THREE_D_FILES',
        IMAGE: 'RECIPE_MAIN_NODES_IMPORT_NODE_IMAGE',
        SORT_ORDER_BY: 'RECIPE_MAIN_NODES_IMPORT_NODE_SORT_ORDER_BY',
        SORT_DATE_ADDED: 'RECIPE_MAIN_NODES_IMPORT_NODE_SORT_DATE_ADDED',
        SORT_NAME: 'RECIPE_MAIN_NODES_IMPORT_NODE_SORT_NAME',
      },
      COMPARISON: {
        MODE: 'RECIPE_MAIN_NODES_COMPARISON_MODE',
        TOGGLE: 'RECIPE_MAIN_NODES_COMPARISON_TOGGLE',
        SLIDER: 'RECIPE_MAIN_NODES_COMPARISON_SLIDER',
        IMAGE: 'RECIPE_MAIN_NODES_COMPARISON_IMAGE',
        VIDEO: 'RECIPE_MAIN_NODES_COMPARISON_VIDEO',
      },
    },
    GROUP_CONTEXT_MENU: {
      NEW_NODE: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_NEW_NODE',
      DOWNLOAD_ALL: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_DOWNLOAD_ALL',
      CLEAR_ALL_ASSETS: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_CLEAR_ALL_ASSETS',
      GROUP_ACTIONS: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_GROUP_ACTIONS',
      DUPLICATE: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_DUPLICATE',
      LABEL_SIZE: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_LABEL_SIZE',
      LABEL_SIZE_OPTIONS: {
        SMALL: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_LABEL_SIZE_OPTIONS_SMALL',
        MEDIUM: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_LABEL_SIZE_OPTIONS_MEDIUM',
        LARGE: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_LABEL_SIZE_OPTIONS_LARGE',
      },
      LOCK: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_LOCK',
      UNLOCK: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_UNLOCK',
      RESIZE_TO_FIT: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_RESIZE_TO_FIT',
      UNGROUP: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_UNGROUP',
      DELETE: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_DELETE',
    },
    SELECTION_CONTEXT_MENU: {
      DELETE_ALL: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_DELETE_ALL',
      CLEAR: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_CLEAR',
      CLEAR_ALL_ASSETS: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_CLEAR_ALL_ASSETS',
      CLEAR_ALL_BUT_SELECTED: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_CLEAR_ALL_BUT_SELECTED',
      DOWNLOAD_ALL: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_DOWNLOAD_ALL',
      DUPLICATE: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_DUPLICATE',
      GROUP_SELECTION: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_GROUP_SELECTION',
      CREATE_IMAGE_ITERATOR: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_CREATE_IMAGE_ITERATOR',
      CREATE_VIDEO_ITERATOR: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_CREATE_VIDEO_ITERATOR',
      CREATE_TEXT_ITERATOR: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_CREATE_TEXT_ITERATOR',
    },
  },
  SETTINGS: {
    DELETE_ACCOUNT: 'SETTINGS_DELETE_ACCOUNT',
    MODEL_MANAGEMENT: {
      TITLE: 'SETTINGS_MODEL_MANAGEMENT_TITLE',
      SUBTITLE: 'SETTINGS_MODEL_MANAGEMENT_SUBTITLE',
      SUBTITLE_VERIFIED: 'SETTINGS_MODEL_MANAGEMENT_SUBTITLE_VERIFIED',
      TEXT_VERIFIED: 'SETTINGS_MODEL_MANAGEMENT_TEXT_VERIFIED',
      SUBTITLE_UNVERIFIED: 'SETTINGS_MODEL_MANAGEMENT_SUBTITLE_UNVERIFIED',
      TEXT_UNVERIFIED: 'SETTINGS_MODEL_MANAGEMENT_TEXT_UNVERIFIED',
      TABLE: {
        HEADER_NAME: 'SETTINGS_MODEL_MANAGEMENT_TABLE_HEADER_NAME',
        HEADER_APPROVED: 'SETTINGS_MODEL_MANAGEMENT_TABLE_HEADER_ALLOWED',
        HEADER_DATE_ADDED: 'SETTINGS_MODEL_MANAGEMENT_TABLE_HEADER_DATE_ADDED',
        SEARCH_PLACEHOLDER: 'SETTINGS_MODEL_MANAGEMENT_TABLE_SEARCH_PLACEHOLDER',
        NO_MODELS_FOUND: 'SETTINGS_MODEL_MANAGEMENT_TABLE_NO_MODELS_FOUND',
        TERMS: 'SETTINGS_MODEL_MANAGEMENT_TABLE_TERMS',
        STATUS: 'SETTINGS_MODEL_MANAGEMENT_TABLE_STATUS',
        LINKS: {
          TERMS: 'SETTINGS_MODEL_MANAGEMENT_TABLE_LINKS_TERMS',
          ADDITIONAL_TERMS: 'SETTINGS_MODEL_MANAGEMENT_TABLE_LINKS_ADDITIONAL_TERMS',
          PRIVACY: 'SETTINGS_MODEL_MANAGEMENT_TABLE_LINKS_PRIVACY',
        },
      },
      DESCRIPTION_SHORT: 'SETTINGS_MODEL_MANAGEMENT_DESCRIPTION_SHORT',
      READ_MORE: 'SETTINGS_MODEL_MANAGEMENT_READ_MORE',
      READ_LESS: 'SETTINGS_MODEL_MANAGEMENT_READ_LESS',
      AUTO_APPROVE_VERIFIED: {
        LABEL: 'SETTINGS_MODEL_MANAGEMENT_AUTO_APPROVE_VERIFIED_LABEL',
        DESCRIPTION: 'SETTINGS_MODEL_MANAGEMENT_AUTO_APPROVE_VERIFIED_DESCRIPTION',
        ERROR: 'SETTINGS_MODEL_MANAGEMENT_AUTO_APPROVE_VERIFIED_ERROR',
      },
      ERROR_UPDATING_APPROVED: 'SETTINGS_MODEL_MANAGEMENT_ERROR_UPDATING_ALLOWED',
      FILTERS: {
        ALL: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_ALL',
        ADMIN_APPROVAL: {
          LABEL: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_ADMIN_APPROVAL_LABEL',
          APPROVED: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_ADMIN_APPROVAL_APPROVED',
          NOT_APPROVED: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_ADMIN_APPROVAL_NOT_APPROVED',
        },
        STATUS: {
          LABEL: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_STATUS_LABEL',
          VERIFIED: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_STATUS_VERIFIED',
          NOT_VERIFIED: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_STATUS_NOT_VERIFIED',
        },
      },
    },
    WORKSPACE_SETTINGS: {
      FORM: {
        NAME: 'SETTINGS_WORKSPACE_SETTINGS_FORM_NAME',
        GENERAL: 'SETTINGS_WORKSPACE_SETTINGS_FORM_GENERAL',
      },
      CREDITS_TITLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_TITLE',
      CURRENT_AMOUNT: 'SETTINGS_WORKSPACE_SETTINGS_CURRENT_AMOUNT',
      DOWNLOAD_CREDITS_REPORT: 'SETTINGS_WORKSPACE_SETTINGS_DOWNLOAD_CREDITS_REPORT',
      CREDITS_REPORT_MODAL: {
        TITLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_TITLE',
        TIME_PERIOD_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_TIME_PERIOD_LABEL',
        DATE_RANGE_CURRENT_CYCLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_DATE_RANGE_CURRENT_CYCLE',
        DATE_RANGE_LAST_30_DAYS: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_DATE_RANGE_LAST_30_DAYS',
        DATE_RANGE_LAST_90_DAYS: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_DATE_RANGE_LAST_90_DAYS',
        DATE_RANGE_ALL_TIME: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_DATE_RANGE_ALL_TIME',
        CANCEL_BUTTON: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_CANCEL_BUTTON',
        DOWNLOAD_BUTTON: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_DOWNLOAD_BUTTON',
        ERROR_MESSAGE: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_ERROR_MESSAGE',
      },
      REMAINING_MONTHLY_CREDITS_TEXT: 'SETTINGS_WORKSPACE_SETTINGS_REMAINING_MONTHLY_CREDITS_TEXT',
      EXTRA_CREDITS_TEXT: 'SETTINGS_WORKSPACE_SETTINGS_EXTRA_CREDITS_TEXT',
      ROLLOVER_CREDITS_TEXT: 'SETTINGS_WORKSPACE_SETTINGS_ROLLOVER_CREDITS_TEXT',
      CREDIT_THRESHOLD_ALERTS_TITLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDIT_THRESHOLD_ALERTS_TITLE',
      CREDIT_THRESHOLD_ALERTS_SUBTITLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDIT_THRESHOLD_ALERTS_SUBTITLE',
      CREDIT_THRESHOLD_ALERTS_ERROR: 'SETTINGS_WORKSPACE_SETTINGS_CREDIT_THRESHOLD_ALERTS_ERROR',
      CREDITS: {
        UPGRADE_CTA: 'SETTINGS_WORKSPACE_SETTINGS_UPGRADE_CTA',
        UPGRADE_CTA_FREE_TOOLTIP: 'SETTINGS_WORKSPACE_SETTINGS_UPGRADE_CTA_FREE_TOOLTIP',
      },
      PLAN: {
        PLAN: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_PLAN',
        SEATS: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_SEATS',
        SEATS_SUFFIX: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_SEATS_SUFFIX',
        RENEWAL_DATE: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_RENEWAL_DATE',
        EXPIRATION_DATE: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_EXPIRATION_DATE',
        DOWNGRADE_TEXT: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_DOWNGRADE_TEXT',
        MONTHLY_CREDITS: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_MONTHLY_CREDITS',
        MONTHLY_CREDITS_TOOLTIP_RESET: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_MONTHLY_CREDITS_TOOLTIP_RESET',
        MONTHLY_CREDITS_TOOLTIP_ROLLOVER: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_MONTHLY_CREDITS_TOOLTIP_ROLLOVER',
      },
      UPGRADE: 'SETTINGS_WORKSPACE_SETTINGS_UPGRADE',
      MANAGE_BILLING: 'SETTINGS_WORKSPACE_SETTINGS_MANAGE_BILLING',
      CANCEL_PLAN: 'SETTINGS_WORKSPACE_SETTINGS_CANCEL_PLAN',
      CANCEL_PLAN_DIALOG: {
        TITLE: 'SETTINGS_WORKSPACE_SETTINGS_CANCEL_PLAN_DIALOG_TITLE',
        MESSAGE: 'SETTINGS_WORKSPACE_SETTINGS_CANCEL_PLAN_DIALOG_MESSAGE',
        CONFIRM: 'SETTINGS_WORKSPACE_SETTINGS_CANCEL_PLAN_DIALOG_CONFIRM',
        CANCEL: 'SETTINGS_WORKSPACE_SETTINGS_CANCEL_PLAN_DIALOG_CANCEL',
      },
      CONTACT_US_PART_1: 'SETTINGS_WORKSPACE_SETTINGS_CONTACT_US_PART_1',
      CONTACT_US_PART_2: 'SETTINGS_WORKSPACE_SETTINGS_CONTACT_US_PART_2',
      CHANGE_PLAN: 'SETTINGS_WORKSPACE_SETTINGS_CHANGE_PLAN',
      API_KEYS: {
        PAGE_TITLE: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_PAGE_TITLE',
        PAGE_DESCRIPTION: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_PAGE_DESCRIPTION',
        COLUMN_PROVIDER: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_COLUMN_PROVIDER',
        COLUMN_CREDENTIALS: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_COLUMN_CREDENTIALS',
        COLUMN_STATUS: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_COLUMN_STATUS',
        EDIT: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_EDIT',
        DELETE_KEY_ARIA: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DELETE_KEY_ARIA',
        ADD_KEY_ARIA: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_ADD_KEY_ARIA',
        ADD_TOOLTIP: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_ADD_TOOLTIP',
        DELETE_TOOLTIP: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DELETE_TOOLTIP',
        ENABLE_TOOLTIP: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_ENABLE_TOOLTIP',
        DISABLE_TOOLTIP: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DISABLE_TOOLTIP',
        INPUT_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_INPUT_LABEL',
        KEY_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_KEY_LABEL',
        SAVE: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_SAVE',
        CANCEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_CANCEL',
        API_KEY_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_API_KEY_LABEL',
        GOOGLE_SERVICE_EMAIL_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_GOOGLE_SERVICE_EMAIL_LABEL',
        GOOGLE_SERVICE_EMAIL_PLACEHOLDER: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_GOOGLE_SERVICE_EMAIL_PLACEHOLDER',
        GOOGLE_PROJECT_ID_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_GOOGLE_PROJECT_ID_LABEL',
        GOOGLE_PROJECT_ID_PLACEHOLDER: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_GOOGLE_PROJECT_ID_PLACEHOLDER',
        GOOGLE_PRIVATE_KEY_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_GOOGLE_PRIVATE_KEY_LABEL',
        GOOGLE_PRIVATE_KEY_PLACEHOLDER: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_GOOGLE_PRIVATE_KEY_PLACEHOLDER',
        LOAD_FAILED: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_LOAD_FAILED',
        OPERATION_FAILED: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_OPERATION_FAILED',
        DELETE_CONFIRM: {
          TITLE: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DELETE_CONFIRM_TITLE',
          BODY: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DELETE_CONFIRM_BODY',
          CANCEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DELETE_CONFIRM_CANCEL',
          CONFIRM: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DELETE_CONFIRM_CONFIRM',
        },
        DISCLAIMER: {
          TITLE: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DISCLAIMER_TITLE',
          HEADS_UP: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DISCLAIMER_HEADS_UP',
          BODY: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DISCLAIMER_BODY',
          CONTINUE: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DISCLAIMER_CONTINUE',
        },
        PROVIDERS: {
          GOOGLE: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_PROVIDER_GOOGLE',
          FAL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_PROVIDER_FAL',
        },
      },
      CREDITS_ALLOCATION: {
        TITLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_TITLE',
        DEFAULT_ALLOCATION_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_DEFAULT_ALLOCATION_LABEL',
        UNLIMITED: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_UNLIMITED',
        EDIT_DEFAULT_ALLOCATION_CTA: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_EDIT_DEFAULT_ALLOCATION_CTA',
        CHANGE_DEFAULT_ALLOCATION_MODAL: {
          TITLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_TITLE',
          SUBTITLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_SUBTITLE',
          CTA_CONFIRM: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_CTA_CONFIRM',
          CTA_CANCEL: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_CTA_CANCEL',
          BUTTON_UNLIMITED_TITLE:
            'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_BUTTON_UNLIMITED_TITLE',
          BUTTON_UNLIMITED_SUBTITLE:
            'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_BUTTON_UNLIMITED_SUBTITLE',
          BUTTON_LIMIT_TITLE:
            'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_BUTTON_LIMIT_TITLE',
          BUTTON_LIMIT_SUBTITLE:
            'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_BUTTON_LIMIT_SUBTITLE',
          CREDITS_ESTIMATION_TEXT:
            'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_CREDITS_ESTIMATION_TEXT',
        },
      },
    },
    MENU: {
      PROFILE: 'SETTINGS_MENU_PROFILE',
      WORKSPACE_SETTINGS: 'SETTINGS_MENU_WORKSPACE_SETTINGS',
      MEMBERS: 'SETTINGS_MENU_MEMBERS',
      API_KEYS: 'SETTINGS_MENU_API_KEYS',
      MODEL_MANAGEMENT: 'SETTINGS_MENU_MODEL_MANAGEMENT',
      SIGNOUT: 'SETTINGS_MENU_SIGNOUT',
    },
    SETTINGS: 'SETTINGS_SETTINGS',
    TEAM: {
      ACTIVATION_PAGE: {
        ERROR_SUBTITLE: 'SETTINGS_TEAM_ACTIVATION_PAGE_ERROR_SUBTITLE',
        ERROR_TITLE: 'SETTINGS_TEAM_ACTIVATION_PAGE_ERROR_TITLE',
        SUBTITLE: 'SETTINGS_TEAM_ACTIVATION_PAGE_SUBTITLE',
        TITLE: 'SETTINGS_TEAM_ACTIVATION_PAGE_TITLE',
      },
      EMPTY_STATE: {
        CTA: 'SETTINGS_TEAM_EMPTY_STATE_CTA',
        TITLE: 'SETTINGS_TEAM_EMPTY_STATE_TITLE',
      },
      INVITE_USER_MODAL: {
        TITLE: 'SETTINGS_TEAM_INVITE_USER_MODAL_TITLE',
        SEATS: 'SETTINGS_TEAM_INVITE_USER_MODAL_SEATS',
        SEATS_ZERO_SUBTITLE: 'SETTINGS_TEAM_INVITE_USER_MODAL_SEATS_ZERO_SUBTITLE',
        TEAM_SEAT_LIMIT_EXCEEDED_PART_1: 'SETTINGS_TEAM_INVITE_USER_MODAL_TEAM_SEAT_LIMIT_EXCEEDED_PART_1',
        TEAM_SEAT_LIMIT_EXCEEDED_PART_2_MONTHLY:
          'SETTINGS_TEAM_INVITE_USER_MODAL_TEAM_SEAT_LIMIT_EXCEEDED_PART_2_MONTHLY',
        TEAM_SEAT_LIMIT_EXCEEDED_PART_2_YEARLY:
          'SETTINGS_TEAM_INVITE_USER_MODAL_TEAM_SEAT_LIMIT_EXCEEDED_PART_2_YEARLY',
        TEAM_SEAT_LIMIT_EXCEEDED_PART_3: 'SETTINGS_TEAM_INVITE_USER_MODAL_TEAM_SEAT_LIMIT_EXCEEDED_PART_3',
        ENTERPRISE_SEAT_LIMIT_EXCEEDED: 'SETTINGS_TEAM_INVITE_USER_MODAL_ENTERPRISE_SEAT_LIMIT_EXCEEDED',
        SUCCESS_MESSAGE: 'INVITE_USER_MODAL_SUCCESS_MESSAGE',
        INVITE_ERROR: 'SETTINGS_TEAM_INVITE_USER_MODAL_INVITE_ERROR',
        PARTIAL_SUCCESS: 'SETTINGS_TEAM_INVITE_USER_MODAL_PARTIAL_SUCCESS',
      },
      JOIN_TEAM_SUCCESS: 'SETTINGS_TEAM_JOIN_TEAM_SUCCESS',
      REMOVE_MEMBER_DIALOG: {
        CONTENT: 'SETTINGS_TEAM_REMOVE_MEMBER_DIALOG_CONTENT',
        INVITED_CONTENT: 'SETTINGS_TEAM_REMOVE_MEMBER_DIALOG_INVITED_CONTENT',
      },
      TEAM_TABLE: {
        ADD_MEMBERS_BUTTON: 'SETTINGS_TEAM_TABLE_ADD_MEMBERS_BUTTON',
        SEARCH_PLACEHOLDER: 'SETTINGS_TEAM_TABLE_SEARCH_PLACEHOLDER',
        TABLE_TITLE_SUFFIX: 'SETTINGS_TEAM_TABLE_TABLE_TITLE_SUFFIX',
        HEADER_NAME: 'SETTINGS_TEAM_TABLE_HEADER_NAME',
        HEADER_ROLE: 'SETTINGS_TEAM_TABLE_HEADER_ROLE',
        HEADER_CREDITS: 'SETTINGS_TEAM_TABLE_HEADER_CREDITS',
        HEADER_USAGE: 'SETTINGS_TEAM_TABLE_HEADER_USAGE',
        HEADER_STATUS: 'SETTINGS_TEAM_TABLE_HEADER_STATUS',
        EDIT_LIMIT_MODAL: {
          TITLE: 'SETTINGS_TEAM_TABLE_EDIT_LIMIT_MODAL_TITLE',
          SUBTITLE: 'SETTINGS_TEAM_TABLE_EDIT_LIMIT_MODAL_SUBTITLE',
        },
        SELECTED_MEMBERS_COUNT: 'SETTINGS_TEAM_TABLE_SELECTED_MEMBERS_COUNT',
        ALLOCATED_CREDITS: 'SETTINGS_TEAM_TABLE_ALLOCATED_CREDITS',
        RESET_TO_DEFAULT: 'SETTINGS_TEAM_TABLE_RESET_TO_DEFAULT',
      },

      USER_STATUS: {
        ACTIVE: 'SETTINGS_TEAM_USER_STATUS_ACTIVE',
        INVITED: 'SETTINGS_TEAM_USER_STATUS_INVITED',
      },
      WORKSPACE_CREDITS: 'SETTINGS_TEAM_WORKSPACE_CREDITS',
      WORKSPACE_CREDITS_CTA: 'SETTINGS_TEAM_WORKSPACE_CREDITS_CTA',
      WORKSPACE_MEMBERS_CAN_SEE_CREDITS: 'SETTINGS_TEAM_WORKSPACE_MEMBERS_CAN_SEE_CREDITS',
      WORKSPACE_NAME: 'SETTINGS_TEAM_WORKSPACE_NAME',
      WORKSPACE_NAME_CHANGE: 'SETTINGS_TEAM_WORKSPACE_NAME_CHANGE',
      WORKSPACE_NAME_PLACEHOLDER: 'SETTINGS_TEAM_WORKSPACE_NAME_PLACEHOLDER',
      YOU: 'SETTINGS_TEAM_YOU',
      WORKSPACE_SUBSCRIPTION_TYPE: 'SETTINGS_TEAM_WORKSPACE_SUBSCRIPTION_TYPE',
      ACTIONS_MENU: {
        DELETE: 'SETTINGS_TEAM_ACTIONS_MENU_DELETE',
        RESEND_INVITE: 'SETTINGS_TEAM_ACTIONS_MENU_RESEND_INVITE',
        COPY_INVITE_LINK: 'SETTINGS_TEAM_ACTIONS_MENU_COPY_INVITE_LINK',
        EDIT_LIMIT: 'SETTINGS_TEAM_ACTIONS_MENU_EDIT_LIMIT',
      },
      CONFIRM_DELETE: {
        TITLE: 'SETTINGS_TEAM_CONFIRM_DELETE_TITLE',
        CONFIRM: 'SETTINGS_TEAM_CONFIRM_DELETE_CONFIRM_TEXT',
      },
      UPGRADE: {
        TITLE: 'SETTINGS_TEAM_UPGRADE_TITLE',
        TEXT: 'SETTINGS_TEAM_UPGRADE_TEXT',
      },
      ROLES: {
        ADMIN: 'SETTINGS_TEAM_ROLES_ADMIN',
        MEMBER: 'SETTINGS_TEAM_ROLES_MEMBER',
      },
    },
  },
  SHARED_DESIGN_APP: {
    NUMBER_OF_RUNS: 'SHARED_DESIGN_APP_NUMBER_OF_RUNS',
    ACTIVATION_PAGE: {
      DEFAULT_ERROR: 'SHARED_DESIGN_APP_ACTIVATION_PAGE_DEFAULT_ERROR',
      TITLE: 'SHARED_DESIGN_APP_ACTIVATION_PAGE_TITLE',
    },
    EDIT_DESIGN_APP_BUTTON: 'SHARED_DESIGN_APP_EDIT_DESIGN_APP_BUTTON',
    INPUTS: {
      DEFAULTS_COMMENT: 'SHARED_DESIGN_APP_INPUTS_DEFAULTS_COMMENT',
      HEADER: {
        ADD_DESCRIPTION: 'SHARED_DESIGN_APP_INPUTS_HEADER_ADD_DESCRIPTION',
        DESCRIPTION_PLACEHOLDER: 'SHARED_DESIGN_APP_INPUTS_DESCRIPTION_PLACEHOLDER',
        DISABLED: 'SHARED_DESIGN_APP_INPUTS_HEADER_DISABLED',
        ENABLED: 'SHARED_DESIGN_APP_INPUTS_HEADER_ENABLED',
      },
      MULTI_LORA: {
        WEIGHT: 'SHARED_DESIGN_APP_INPUTS_MULTI_LORA_WEIGHT',
      },
      PARAMS_DRAWER: {
        SET_AS_INPUT: 'SHARED_DESIGN_APP_INPUTS_PARAMS_DRAWER_SET_AS_INPUT',
      },
      PROMPT: {
        PLACEHOLDER: 'SHARED_DESIGN_APP_INPUTS_PROMPT_PLACEHOLDER',
      },
      REQUIRED_ERROR: 'SHARED_DESIGN_APP_INPUTS_REQUIRED_ERROR',
      REQUIRED_ERROR_FILE: 'SHARED_DESIGN_APP_INPUTS_REQUIRED_ERROR_FILE',
      REQUIRED_ERROR_LORA: 'SHARED_DESIGN_APP_INPUTS_REQUIRED_ERROR_LORA',
      REQUIRED_ERROR_TEXT_ITERATOR: 'SHARED_DESIGN_APP_INPUTS_REQUIRED_ERROR_TEXT_ITERATOR',
      REQUIRED_ERROR_MEDIA_ITERATOR: 'SHARED_DESIGN_APP_INPUTS_REQUIRED_ERROR_MEDIA_ITERATOR',
      SET_AS_PARAMETER: 'SHARED_DESIGN_APP_INPUTS_SET_AS_PARAMETER',
    },
    MODAL: {
      BUTTON_CTA: 'SHARED_DESIGN_APP_MODAL_BUTTON_CTA',
      DEFAULT_ERROR: 'SHARED_DESIGN_APP_MODAL_DEFAULT_ERROR',
      LINK_COPIED: 'SHARED_DESIGN_APP_MODAL_LINK_COPIED',
      TITLE: 'SHARED_DESIGN_APP_MODAL_TITLE',
    },
    NO_INPUTS: {
      TIP: 'SHARED_DESIGN_APP_TOOLBAR_NO_INPUTS_TIP',
      TITLE: 'SHARED_DESIGN_APP_TOOLBAR_NO_INPUTS_TITLE',
    },
    PREVIEW_DESIGN_APP_BUTTON: 'SHARED_DESIGN_APP_PREVIEW_DESIGN_APP_BUTTON',
    PUBLISH_DESIGN_APP_BUTTON: 'SHARED_DESIGN_APP_PUBLISH_DESIGN_APP_BUTTON',
    PUBLISH_DESIGN_APP_FAILED: 'SHARED_DESIGN_APP_PUBLISH_DESIGN_APP_FAILED',
    PUBLISH_DESIGN_APP_SUCCESS: 'SHARED_DESIGN_APP_PUBLISH_DESIGN_APP_SUCCESS',
    TOOLBAR: {
      CURRENT_VERSION: 'SHARED_DESIGN_APP_TOOLBAR_CURRENT_VERSION',
      LAST_PUBLISHED_AT: 'SHARED_DESIGN_APP_TOOLBAR_LAST_PUBLISHED_AT',
      LATEST_VERSION: 'SHARED_DESIGN_APP_TOOLBAR_LATEST_VERSION',
      NO_VERSIONS: 'SHARED_DESIGN_APP_TOOLBAR_NO_VERSIONS',
      VIEW_VERSION: 'SHARED_DESIGN_APP_TOOLBAR_VIEW_VERSION',
    },
  },
  SHARE_WORKFLOW_MODAL: {
    EMAIL_PLACEHOLDER: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_EMAIL_PLACEHOLDER',
    INPUTS: {
      PROMPT_PLACEHOLDER: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_INPUTS_PROMPT_PLACEHOLDER',
    },
    LINK: {
      ANYONE: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_LINK_ANYONE',
      ORGANIZATION: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_LINK_ORGANIZATION',
      RESTRICTED: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_LINK_RESTRICTED',
      TEAM: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_LINK_TEAM',
    },
    PUBLISH_TO_FIGMA_COMMUNITY: {
      ROW_LABEL: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_PUBLISH_TO_FIGMA_COMMUNITY_ROW_LABEL',
      MODAL: {
        TITLE_PUBLISH: 'PUBLISH_TO_COMMUNITY_MODAL_TITLE_PUBLISH',
        STEPS: {
          DESCRIPTION: 'PUBLISH_TO_COMMUNITY_MODAL_STEPS_DESCRIPTION',
          IMAGES: 'PUBLISH_TO_COMMUNITY_MODAL_STEPS_IMAGES',
          DETAILS: 'PUBLISH_TO_COMMUNITY_MODAL_STEPS_DETAILS',
        },
        DESCRIPTION_STEP: {
          NAME_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DESCRIPTION_STEP_NAME_LABEL',
          DESCRIPTION_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DESCRIPTION_STEP_DESCRIPTION_LABEL',
          DESCRIPTION_PLACEHOLDER: 'PUBLISH_TO_COMMUNITY_MODAL_DESCRIPTION_STEP_DESCRIPTION_PLACEHOLDER',
          CATEGORY_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DESCRIPTION_STEP_CATEGORY_LABEL',
          TAGS_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DESCRIPTION_STEP_TAGS_LABEL',
        },
        IMAGES_STEP: {
          THUMBNAIL_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_IMAGES_STEP_THUMBNAIL_LABEL',
          GALLERY_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_IMAGES_STEP_GALLERY_LABEL',
          RECOMMENDED_SIZE: 'PUBLISH_TO_COMMUNITY_MODAL_IMAGES_STEP_RECOMMENDED_SIZE',
          UPLOAD: 'PUBLISH_TO_COMMUNITY_MODAL_IMAGES_STEP_UPLOAD',
          CHOOSE_FROM_GALLERY: 'PUBLISH_TO_COMMUNITY_MODAL_IMAGES_STEP_CHOOSE_FROM_GALLERY',
        },
        DETAILS_STEP: {
          EMAIL_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_EMAIL_LABEL',
          PROFILE_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_PROFILE_LABEL',
          TERMS_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_TERMS_LABEL',
          TERMS_AGREE_PREFIX: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_TERMS_AGREE_PREFIX',
          TERMS_LINK: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_TERMS_LINK',
          COMMENTS_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_COMMENTS_LABEL',
          COMMENTS_TOGGLE: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_COMMENTS_TOGGLE',
        },
        FOOTER: {
          NEXT: 'PUBLISH_TO_COMMUNITY_MODAL_FOOTER_NEXT',
          PUBLISH: 'PUBLISH_TO_COMMUNITY_MODAL_FOOTER_PUBLISH',
        },
        ERRORS: {
          NAME_REQUIRED: 'PUBLISH_TO_COMMUNITY_MODAL_ERRORS_NAME_REQUIRED',
          DESCRIPTION_REQUIRED: 'PUBLISH_TO_COMMUNITY_MODAL_ERRORS_DESCRIPTION_REQUIRED',
          IMAGE_REQUIRED: 'PUBLISH_TO_COMMUNITY_MODAL_ERRORS_IMAGE_REQUIRED',
        },
      },
    },
    SHARE_BUTTON: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_SHARE_BUTTON',
    SHARE_BUTTON_LOADING: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_SHARE_BUTTON_LOADING',
    SUCCESS_MESSAGE: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_SUCCESS_MESSAGE',
    TITLE: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_TITLE',
    OWNER: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_OWNER',
    ACCESS_TITLE: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_ACCESS_TITLE',
    REMOVE: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_REMOVE',
    FREE_PLAN_TOOLTIP: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_FREE_PLAN_TOOLTIP',
  },
  SIGN_IN_PAGE: {
    CANT_SIGN_IN_MESSAGE: 'SIGN_IN_PAGE_CANT_SIGN_IN_MESSAGE',
    GOOGLE_SIGN_IN_BUTTON: 'SIGN_IN_PAGE_GOOGLE_SIGN_IN_BUTTON',
    MICROSOFT_SIGN_IN_BUTTON: 'SIGN_IN_PAGE_MICROSOFT_SIGN_IN_BUTTON',
    FIGMA_SIGN_IN_BUTTON: 'SIGN_IN_PAGE_FIGMA_SIGN_IN_BUTTON',
    OR: 'SIGN_IN_PAGE_OR',
    TITLE: 'SIGN_IN_PAGE_TITLE',
    SUBTITLE: 'SIGN_IN_PAGE_SUBTITLE',
    TERMS_TEXT: 'SIGN_IN_PAGE_TERMS_TEXT',
    TERMS_OF_SERVICE_LINK: 'SIGN_IN_PAGE_TERMS_OF_SERVICE_LINK',
    PRIVACY_POLICY_LINK: 'SIGN_IN_PAGE_PRIVACY_POLICY_LINK',
    EMAIL_DOMAIN_UNAUTHORIZED: 'SIGN_IN_PAGE_EMAIL_DOMAIN_UNAUTHORIZED',
    EMAIL_PASSWORD_LOGIN_NOT_ALLOWED: 'SIGN_IN_EMAIL_PASSWORD_LOGIN_NOT_ALLOWED',
    TOS_DIALOG_TITLE: 'SIGN_IN_PAGE_TOS_DIALOG_TITLE',
    TOS_DIALOG_BODY: 'SIGN_IN_PAGE_TOS_DIALOG_BODY',
    TOS_DIALOG_ACCEPT_BUTTON: 'SIGN_IN_PAGE_TOS_DIALOG_ACCEPT_BUTTON',
  },
  UPGRADE_MODAL: {
    CTA: 'UPGRADE_MODEL_CTA',
    TITLE: 'UPGRADE_MODEL_TITLE',
  },
  UPLOAD_LORA_NODE: {
    DEFAULT_WEIGHT: 'DEFAULT_WEIGHT',
    TRIGGER: 'TRIGGER',
    UPLOADING: 'UPLOAD_LORA_NODE_UPLOADING',
    UPLOAD_ANOTHER_BUTTON_TEXT_FILE: 'UPLOAD_LORA_NODE_UPLOAD_ANOTHER_BUTTON_TEXT_FILE',
    UPLOAD_BUTTON_TEXT: 'UPLOAD_LORA_NODE_UPLOAD_BUTTON_TEXT',
  },
  WEAVY_MARKETING: {
    CARDS: {
      SOFT_LAUNCH_INVITE: {
        SUBTITLE: 'MARKETING_CARDS_SOFT_LAUNCH_INVITE_SUBTITLE',
        TITLE: 'MARKETING_CARDS_SOFT_LAUNCH_INVITE_TITLE',
      },
    },
    DASHBOARD_BANNER: {
      SOFT_LAUNCH_INVITE: {
        SUBTITLE: 'MARKETING_DASHBOARD_BANNER_SOFT_LAUNCH_INVITE_SUBTITLE',
        TITLE: 'MARKETING_DASHBOARD_BANNER_SOFT_LAUNCH_INVITE_TITLE',
      },
    },
    APP_BANNER: {
      HOLIDAY_PROMO: {
        TITLE: 'MARKETING_DASHBOARD_BANNER_HOLIDAY_PROMO_TITLE',
        SUBTITLE: 'MARKETING_DASHBOARD_BANNER_HOLIDAY_PROMO_SUBTITLE',
        DISCLAIMER: 'MARKETING_DASHBOARD_BANNER_HOLIDAY_PROMO_DISCLAIMER',
      },
    },
    MODALS: {
      SOFT_LAUNCH_INVITE: {
        CONTENT_BOTTOM: 'MARKETING_MODALS_SOFT_LAUNCH_INVITE_CONTENT_BOTTOM',
        CONTENT_TOP: 'MARKETING_MODALS_SOFT_LAUNCH_INVITE_CONTENT_TOP',
        ERROR_EMAIL_ALREADY_INVITED: 'MARKETING_MODALS_SOFT_LAUNCH_INVITE_ERROR_EMAIL_ALREADY_INVITED',
        INVITE_BUTTON: 'MARKETING_MODALS_SOFT_LAUNCH_INVITE_INVITE_BUTTON',
        PLACEHOLDER: 'MARKETING_MODALS_SOFT_LAUNCH_INVITE_PLACEHOLDER',
        SENT: 'MARKETING_MODALS_SOFT_LAUNCH_INVITE_SENT',
        TITLE: 'MARKETING_MODALS_SOFT_LAUNCH_INVITE_TITLE',
      },
    },
  },
  DASHBOARD: {
    DUPLICATE_SUCCESS: 'DASHBOARD_DUPLICATE_SUCCESS',
    DUPLICATE_SUCCESS_ACTION: 'DASHBOARD_DUPLICATE_SUCCESS_ACTION',
    PAGES: {
      FILES: {
        EMPTY_STATE: {
          TITLE: 'DASHBOARD_PAGES_FILES_EMPTY_STATE_TITLE',
          DESCRIPTION: 'DASHBOARD_PAGES_FILES_EMPTY_STATE_DESCRIPTION',
          ACTION: 'DASHBOARD_PAGES_FILES_EMPTY_STATE_ACTION',
        },
        TITLE: 'DASHBOARD_PAGES_FILES_TITLE',
        RECIPE_CARD: {
          SUBTITLE_CREATED: 'DASHBOARD_PAGES_FILES_RECIPE_CARD_SUBTITLE_CREATED',
          SUBTITLE_LAST_EDITED: 'DASHBOARD_PAGES_FILES_RECIPE_CARD_SUBTITLE_LAST_EDITED',
          OWNED_BY_YOU: 'DASHBOARD_PAGES_FILES_RECIPE_CARD_OWNED_BY_YOU',
          OWNED_BY_OTHER: 'DASHBOARD_PAGES_FILES_RECIPE_CARD_OWNED_BY_OTHER',
        },
        FOLDER_CARD: {
          FILE_COUNT_SINGULAR: 'DASHBOARD_PAGES_FILES_FOLDER_CARD_FILE_COUNT_SINGULAR',
          FILE_COUNT_PLURAL: 'DASHBOARD_PAGES_FILES_FOLDER_CARD_FILE_COUNT_PLURAL',
        },
      },
      SHARED_WITH_ME: {
        TITLE: 'DASHBOARD_PAGES_SHARED_WITH_ME_TITLE',
        EMPTY_STATE: {
          TITLE: 'DASHBOARD_PAGES_SHARED_WITH_ME_EMPTY_STATE_TITLE',
          ACTION: 'DASHBOARD_PAGES_SHARED_WITH_ME_EMPTY_STATE_ACTION',
        },
      },
      WORKSPACE_FILES: {
        TITLE: 'DASHBOARD_PAGES_WORKSPACE_FILES_TITLE',
        EMPTY_STATE: {
          TITLE: 'DASHBOARD_PAGES_WORKSPACE_FILES_EMPTY_STATE_TITLE',
          ACTION: 'DASHBOARD_PAGES_WORKSPACE_FILES_EMPTY_STATE_ACTION',
        },
      },
      SHARED_APPS: {
        TITLE: 'DASHBOARD_PAGES_SHARED_APPS_TITLE',
        EMPTY_STATE: {
          TITLE: 'DASHBOARD_PAGES_SHARED_APPS_EMPTY_STATE_TITLE',
          ACTION: 'DASHBOARD_PAGES_SHARED_APPS_EMPTY_STATE_ACTION',
        },
      },
      ARCHIVE: {
        TITLE: 'DASHBOARD_PAGES_ARCHIVE_TITLE',
        SUBTITLE: 'DASHBOARD_PAGES_ARCHIVE_SUBTITLE',
        RESTORE: 'DASHBOARD_PAGES_ARCHIVE_RESTORE',
        RESTORE_ERROR: 'DASHBOARD_PAGES_ARCHIVE_RESTORE_ERROR',
        RESTORE_WORKFLOW_SUCCESS: 'DASHBOARD_PAGES_ARCHIVE_RESTORE_WORKFLOW_SUCCESS',
        RESTORE_FOLDER_SUCCESS: 'DASHBOARD_PAGES_ARCHIVE_RESTORE_FOLDER_SUCCESS',
        DELETED_AT: 'DASHBOARD_PAGES_ARCHIVE_DELETED_AT',
        DELETED_AT_HEADER: 'DASHBOARD_PAGES_ARCHIVE_DELETED_AT_HEADER',
        EMPTY_STATE: {
          DESCRIPTION: 'DASHBOARD_PAGES_ARCHIVE_EMPTY_STATE_DESCRIPTION',
        },
      },
      COMMUNITY: {
        TITLE: 'DASHBOARD_PAGES_COMMUNITY_TITLE',
        SUBTITLE: 'DASHBOARD_PAGES_COMMUNITY_SUBTITLE',
        MODEL_SAVED: 'DASHBOARD_PAGES_COMMUNITY_MODEL_SAVED',
        CONTEXT_MENU: {
          SAVE_TO_MY_MODELS: 'DASHBOARD_PAGES_COMMUNITY_CONTEXT_MENU_SAVE_TO_MY_MODELS',
        },
        MODEL_CARD: {
          CREATOR: 'DASHBOARD_PAGES_COMMUNITY_MODELS_CREATOR',
          BASED_ON: 'DASHBOARD_PAGES_COMMUNITY_MODELS_BASED_ON',
        },
      },
      MY_MODELS: {
        TITLE: 'DASHBOARD_PAGES_MY_MODELS_TITLE',
        SUBTITLE: 'DASHBOARD_PAGES_MY_MODELS_SUBTITLE',
        EMPTY_STATE: {
          TITLE: 'DASHBOARD_PAGES_MY_MODELS_EMPTY_STATE_TITLE',
          DESCRIPTION: 'DASHBOARD_PAGES_MY_MODELS_EMPTY_STATE_DESCRIPTION',
          ACTION: 'DASHBOARD_PAGES_MY_MODELS_EMPTY_STATE_ACTION',
        },
        DELETE_DIALOG_TITLE: 'DASHBOARD_PAGES_MY_MODELS_DELETE_DIALOG_TITLE',
      },
    },
  },
  VIDEO_PREVIEW: {
    CHANGE_TO_TIMECODE: 'VIDEO_PREVIEW_CHANGE_TO_TIMECODE',
    CHANGE_TO_FRAMES: 'VIDEO_PREVIEW_CHANGE_TO_FRAMES',
    FRAMES: 'VIDEO_PREVIEW_FRAMES',
  },
  TASK_MANAGER: {
    TITLE: 'TASK_MANAGER_TITLE',
    BATCH_NAME: 'TASK_MANAGER_BATCH_NAME',
    RUNNING_TEXT: 'TASK_MANAGER_RUNNING_TEXT',
    CANCELLED_TEXT: 'TASK_MANAGER_CANCELLED_TEXT',
    FAILED_TEXT: 'TASK_MANAGER_FAILED_TEXT',
    FAILED_TEXT_NO_REFUND: 'TASK_MANAGER_FAILED_TEXT_NO_REFUND',
    FAILED_STILL_RUNNING: 'TASK_MANAGER_FAILED_STILL_RUNNING',
    EMPTY_STATE: 'TASK_MANAGER_EMPTY_STATE',
    CLEAR_ALL: 'TASK_MANAGER_CLEAR_ALL',
    NO_ACTIVE_RUNS: 'TASK_MANAGER_NO_ACTIVE_RUNS',
    INITIALIZING: 'TASK_MANAGER_INITIALIZING',
    TASKS: 'TASK_MANAGER_TASKS',
    BATCH_COMPLETED: 'TASK_MANAGER_BATCH_COMPLETED',
  },
  SHORTCUTS: {
    PANEL_TITLE: 'SHORTCUTS_PANEL_TITLE',
    NAVIGATION_MARK_NODES: 'SHORTCUT_NAVIGATION_MARK_NODES',
    NAVIGATION_NAVIGATE_TO_NODES: 'SHORTCUT_NAVIGATION_NAVIGATE_TO_NODES',
    ZOOM_100: 'SHORTCUT_ZOOM_100',
    ZOOM_TO_FIT: 'SHORTCUT_ZOOM_TO_FIT',
    SELECT_ALL_NODES: 'SHORTCUT_SELECT_ALL_NODES',
    RUN_MODEL: 'SHORTCUT_RUN_MODEL',
    GROUP_SELECTION: 'SHORTCUT_GROUP_SELECTION',
    MOVE: 'SHORTCUT_MOVE',
    PAN: 'SHORTCUT_PAN',
    UNDO: 'SHORTCUT_UNDO',
    REDO: 'SHORTCUT_REDO',
    CREATE_IMPORT_NODE: 'SHORTCUT_CREATE_IMPORT_NODE',
    CREATE_PROMPT_NODE: 'SHORTCUT_CREATE_PROMPT_NODE',
  },
  NODES: {
    MODELS: {
      DYNAMIC_HANDLES: {
        IMAGE_URLS: {
          KEY: 'NODES_MODELS_DYNAMIC_HANDLES_IMAGE_URLS_KEY',
          DESCRIPTION: 'NODES_MODELS_DYNAMIC_HANDLES_IMAGE_URLS_DESCRIPTION',
        },
      },
    },
  },
  CSV_COLUMN_DIALOG: {
    TITLE: 'CSV_COLUMN_DIALOG_TITLE',
    DESCRIPTION: 'CSV_COLUMN_DIALOG_DESCRIPTION',
    COLUMN_LABEL: 'CSV_COLUMN_DIALOG_COLUMN_LABEL',
    COLUMN_PLACEHOLDER: 'CSV_COLUMN_DIALOG_COLUMN_PLACEHOLDER',
    CANCEL: 'CSV_COLUMN_DIALOG_CANCEL',
    CONFIRM: 'CSV_COLUMN_DIALOG_CONFIRM',
    ERROR_EMPTY: 'CSV_COLUMN_DIALOG_ERROR_EMPTY',
    ERROR_PARSE: 'CSV_COLUMN_DIALOG_ERROR_PARSE',
    WARNING_TRUNCATED: 'CSV_COLUMN_DIALOG_WARNING_TRUNCATED',
  },
};
